export default {
  component: {
    federatedLoginError: {
      heading: 'Autentisering misslyckades',
      content: 'Vi kunde inte logga in dig. Försök igen senare och kontakta vår support om problemet kvarstår.',
    },

    accountMenu: {
      myAccount: 'Mitt konto',
      billing: 'Fakturering',
      userManagement: 'Användarhantering',
      organisationProfile: 'Organisationens inställningar',
      statistics: 'Statistics',
      videos: 'Videobibliotek',
    },

    adminNavigationBar: {
      dashboard: 'Huvudvy',
      backToMainMenu: 'Tillbaka till huvudmenyn',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'Inga åtgärder',
      show: 'Visa innehåll',
      hide: 'Dölja innehåll',
      action: {
        comment: 'kommenterade ansökan',
        invite: 'inbjöds till intervju',
        schedulingInvite: 'sände kandidaten inbjudan att boka intervjutid.',
        reScheduled: 'ändrade intervjutiden.',
        addedCandidateToRound: 'lade till kandidaten i intervjurundan',
        selectedInterviewTime: 'Kandidaten valde en tid för intervjun',
        reInvite: 'skickade pånytt inbjudan till intervjun åt sökanden',
        smsInvite: 'inbjuden till intervju via textmeddelande',
        smsReInvite: 'inbjudan skickad på nytt till kandidat via textmeddelande',
        videoResponse: 'Kandidaten besvarade videofrågan',
        message: 'skickade e-post',
        personalInterviewMessage: 'har skickat en inbjudan till ett schemalagt möte',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'skickade videomeddelande',
        applicationCreatedByAdmin: 'added this candidate',
        stageChanged: placeholderKeys => `flyttade kandidaten till fasen ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `Kandidaten har svarat på intervjun ${placeholder.opening}`,
        applicationCreated: 'Ansökan är skapad',
        applicationUpdated: 'Ansökan är uppdaterad',
        candidateUpdated: 'Kandidaten är uppdaterad',
        introductionToOne: placeholders => `CKandidaten introducerades till ${placeholders.introducee}`,
        introductionToMany: placeholders => `Kandidaten introducerades till  ${placeholders.introduceeCount} mottagare`,
        calendarEventCreated: placeholders => `Kandidat bekräftade möte: ${placeholders.eventStartTime}`,
        addRating: 'gav omdöme',
        deleteRating: 'tog bort sitt omdöme',
        withdrew: 'Kandidaten drog sig ur processen.',
        resetQuestionResponse: 'tog bort kandidatens svar.',
        joinedLiveInterview: 'Kandidaten anslöt till intervjun',
        evaluated: 'bedömde kandidaten',
      },
      videoLink: {
        linkText: 'Visa innehåll',
      },
    },

    additionalFormFields: {
      delete: 'Radera',
      done: 'Klar',
      cancel: 'Annulera',
      edit: 'Redigera',
      required: 'Krävs',
      optional: 'Frivillig',
      notAsked: 'Inte bett',
      title: 'Formulärets tilläggsfrågor',
      add: 'Skapa nytt fält',
      description: context => (context === 'interview'
        ? 'Tilläggsfält kan ej raderas efter att inbjudningarna har skickats.'
        : 'Tilläggsfält kan ej raderas ifall arbetsannonsen har kandidater.'),
      addOption: 'Lägg till',
      shortText: 'Kort text',
      longText: 'Lång text',
      singleSelect: 'Enval',
      multiSelect: 'Flerval',
      fieldLabelPlaceholder: 'Fältnamn för kandidater',
      fieldNamePlaceholder: 'Fältnamn för rekryteraren',
      addLabel: 'Lägg till rubrik',
      addName: 'Lägg till namn',
      nameLabel: 'Fältnamn',
      typeLabel: 'Fält typ',
      optionLabel: 'Valmöjligheter',
      settingsLabel: 'Formulärinställningar',
      reorder: 'Ordna fälten',
      stopReordering: 'Avsluta ordningen av fält',
      optionPlaceholder: 'Lägg till alternativ',
      optionError: 'Alternativet finns redan',
    },

    addPublicQuestions: {
      title: 'Videofråga',
      description: 'Lägg till ansökans fasfråga här.',
    },

    addQuestions: {
      edit: {
        start: 'Ordna om frågorna',
        stop: 'Sluta ordna om frågorna',
      },
      placeholder: isMobile => (isMobile ? 'Klicka för att ladda up eller spela in en fråga' : 'Klicka för att spela in en fråga'),
      textQuestionPlaceholder: 'Klicka för att skriva en fråga',
      videoPlaceholder: isMobile => (isMobile ? 'Klicka för att ladda up eller spela in ny video' : 'Lägg till ett nytt videoklipp'),
      library: 'Välj från biblioteket',
      text: 'Textfråga',
      record: 'Spela in',
      upload: 'Ladda',
      answerable: 'Frågan kan besvaras',
      required: 'Svar krävs',
      takeLimitLabel: 'Antal försök',
      answerTimeLabel: 'Svarstid',
      preparationTimeLabel: 'Förberedelsetid',
      evaluationCriteriaLabel: 'Bedömningskriterier',
      questionPlaceholder: 'Skriv din fråga här',
      evaluationCriteriaPlaceholder: 'Mata in frågornas bedömningskriterier hä',
      cancel: 'Avbryt',
      add: 'Lägg till',
      unlimitedLabel: 'Obegränsat',
    },

    addVideo: {
      title: 'Arbetsgivarens videoklipp',
      description: 'Marknadsför ditt företags kultur och förbättra arbetsgivaridentiteten genom att lägga till en arbetsgivarvideo till jobbannonsen',
    },

    adminCoverPhoto: {
      welcome: name => `Välkommen, ${name}!`,
      photo: 'Lägg till bakgrundsbild',
      removePhoto: 'Ta bort bakgrundsbild',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://get.recright.com/sv/integritetspolicy/',
      termsLink:
        'https://get.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: 'Ansökningsformulär konfiguration',
      notAsked: 'Inte bett',
      optional: 'Frivillig',
      required: 'Krävs',
      name: 'Namn',
      coverLetter: 'Följebrev',
      email: 'E-postadress',
      phoneNumber: 'Telefonnummer',
      city: 'Stad',
      attachments: 'Bilagor',
      links: 'Länkar',
      questions: 'Videofråga',
      attachmentsDescription: 'Beskrivning av bilagor',
    },

    billingPlanSelector: {
      select: 'Välj',
      removeSelection: 'Återställ val',
      month: '/rekrytering',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright Videointervjuer',
      'single-recruitment': 'Enskild rekrytering',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Recright Anpassad',
      plans: {
        'recright-easy': {
          info: '10 - 20 befattningar/år för små and medelstora organisationer.',
          info2: '10 positioner ingår, med option för 5 eller 10 till.',
          features: [
            'Max. 50 kandidater/befattning',
            'Obegränsat antal användarplatser',
            'Användaradministration',
            'Gratis inspelad videoutbildning',
            'Logga och banner',
            'Kundsupport',
          ],
          unitType: '/månad',
        },
        'recright-pro2': {
          info: 'För företag som regelbundet rekryterar.',
          info2: 'Allt från enskild rekrytering och:',
          features: [
            '10 videorekryteringar på ett år',
            'Max 50 kandidater per videorekrytering',
            'Obegränsat antal användarplatser',
            'Användaradministration',
            'Kundsupport',
            'Varumärkesprofilering (Basic)',
            'Customer Success',
            'Statistik',
          ],
          unitType: '/månad',
        },
        'recright-ats': {
          features: [
            'Rekryteringsverktyg',
            'Obegränsat antal av arbetsannonser',
            'Branding video av arbetsgivaren',
            'In-application videofråga',
            'Kandidatundersökning',
            'Kommunikation med kandidater',
            'Team engagemang',
            'Databas över kandidaterna',
          ],
          unitType: '/månad',
        },
        'recright-video-interview': {
          features: [
            'Recright ATS inkluderat',
            'Inspelade videointervjuer',
            'Många videofrågor',
            'Rapporteringsverktyg',
            'Online-träning',
            '15 videointervjubefattningar per år',
          ],
          unitType: '/månad',
        },
        'recright-custom': {
          features: [
            'Volymbaserad prissättning',
            'Dedikerad kontohanterare',
            'Integration till din ATS',
            'Live video intervju',
          ],
          unitType: '/månad',
        },
        'recright-essential': {
          features: [
            '15 tjänster/år',
            'Max 50 kandidater/tjänst',
            'Obegränsat antal rekryterare',
            'Förinspelad utbildningsvideo',
          ],
          unitType: '/månad',
        },
        'recright-pro': {
          features: [
            '30 tjänster/år',
            'Max 50 kandidater/tjänst',
            'Obegränsat antal rekryterare',
            'Förinspelad utbildningsvideo',
            'Bästa praxis utbildning',
            'Varumärke: logo, banner, fonter, färger',
            'Kandidat Feedpack Puls',
            'Rapportering',
            'Dedikerad kontaktperson',
            'Användarhandtering',
          ],
          unitType: '/månad',
        },
        'recright-premium': {
          features: [
            'Over 50 tjänster/år',
            'Obegränsat antal rekryterare',
            'Bästa praxis utbildning',
            'Varumärke: logo, banner, fonter, färger',
            'Kandidat Feedpack Puls',
            'Rapportering',
            'Dedikerad kontaktperson',
            'Användarhandtering',
            'ATS integration',
            'Live intervju',
            'Active Directory integration',
          ],
          unitType: '/månad',
        },
        'single-recruitment': {
          info: 'Perfekt för att prova den fulla kraften i förinspelade intervjuer',
          features: [
            'Alla funktioner inkluderas',
            'Inkluderar en platsannons och en videointervju',
            'I kraft 60 dagar efter skapandet av annons eller videointervju',
          ],
          unitType: '/rekrytering',
        },
      },
    },

    branding: {
      headerFont: 'Typsnittet för rubriken',
      bodyFont: 'Kroppstypsnitt',
      backgroundColor: 'Bakgrundsfärg',
      textColor: 'Textfärg',
      brandColor: 'Varumärkets färg',
      buttonTextColor: 'Knapptextens färg',
      headerTextColor: 'Rubriktextens färg',
    },

    candidateCard: {
      noStatus: 'Ingen status inställd',
      lastSeen: time => `Senast sedd ${time}.`,
      notVisited: 'Har inte besökt på intervju.',
    },

    comments: {
      placeholder: 'Lägg till ny kommentar',
      submit: 'Lägg till',
      delete: 'Radera',
      showComments: 'Visa andras kommentarer',
      hideComments: 'Dölj andras kommentarer',
    },

    competencyList: {
      duplicateError: 'Kompetens med detta namn existerar redan',
      defaultText: 'Vi har definierat några bra standarkompetenser till att börja med, ifall du är osäker på vilka kompetenser du skall använda.',
      defaultLinkText: 'Hämta standarkompetenserna',
      addCompetency: 'Lägg till ny kompetens',
    },

    chooseLicenseLink: {
      title: 'Välj licens',
    },

    currentFilters: {
      currentFilters: 'Aktuell filter:',
    },

    emailForm: {
      emailLabel: 'E-postadress',
      defaultButtonText: 'Skicka',
    },

    filterToggler: {
      hideFilters: 'Göm filtrar',
      showFilters: 'Visa filtrar',
    },

    hashtags: {
      placeholder: 'Lägg till en tagg',
      delete: 'Radera',
    },

    imageInput: {
      errors: {
        format: 'Filen är inte en bild.',
        size: 'Bildfilen är för stor, max.storlek för filen är 4 MB.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Ämne',
      messagePlaceholder: 'Meddelande',
      namePlaceholder: 'Namn',
      namePlaceholder2:
        'Om det lämnas tomt, kommer standardhälsningen att användas i det skickade meddelandet.',
      templateNameLabel: 'Mallnamn',
      titleDisclaimer:
        '[INTERVIEW TITLE] kommer att ersättas med intervjurubriken när inbjudningarna skickas.',
      titleDisclaimerJob:
        '[JOB TITLE] kommer att ersättas med jobbrubriken när meddelandet skickas.',
      confirmLanguageChange:
        'Är du säker på att du vill byta språk? Alla ändringar som inte har sparats kommer att gå förlorade.',
      formatInfo:
        'Du kan lägga till text i fetstil och kursiv stil, eller länkar med special formatering:',
      cursive: '_Kursiv stil_',
      bolded: '*Fetstil*',
      link: '[http://example.com|Länktext]',
      greetingLabel: 'Hälsning',
      greetingPlaceholder:
        'Hälsning som visas i slutet av meddelandet före signaturen.',
      greetingPlaceholder2: defaultGreeting =>
        `Om den lämnas tom, kommer standardhälsningen ${defaultGreeting} att användas i det skickade meddelandet.`,
      getDefaultGreeting: 'Hämta standardhälsning',
    },

    liveEvaluation: {
      interviewTabLabel: 'Intervju',
      evaluationTabLabel: 'Utvärdering',
      interviewNotesLabel: 'Intervjuanteckningar',
      evaluationNotesLabel: 'Utvärderingsanteckningar',
      thankYouLabel: 'Tack!',
      evaluationSavedLabel: 'Vi har sparat din utvärdering av kandidaten.',
      evaluatorLabel: 'Utvärderare',
      evaluatorCount: count => (count === 1 ? '1 har utvärderat' : `${count} har utvärderat`),
      interviewersLabel: 'Intervjuare',
      transcriptLoadingLabel: 'Transkript laddas',
      recordingLabel: 'Intervjuns inspelning',
      evaluationNotesPlaceholder: stepTitle => `Anteckningar för ${stepTitle}`,
      goToAILabel: 'Hoppa till AI anteckningar',
      goBackLabel: 'Gå tillbaka upp',
      AISummaryLabel: 'AI sammanfattning',
      AINotesLabel: 'AI anteckningar',
      AIInsightsLabel: 'AI insikter',
      aiAssistant: 'AI assistent',
      average: 'Medeltal',
      continueLaterLabel: 'Fortsätt senare',
      transcriptButtonText: 'Intervjutranskript',
      transcriptionError: 'Fel vid hämtning av transkript',
      finishAndSubmitLabel: 'Avsluta utvärderingen',
      averageForAllSections: 'Medeltal för hela intervjun',
      continueLaterText: title =>
        `Vi har skickat dig ett e-postmeddelande med länken så att du kan fortsätta utvärderingen av kandidaten i intervju ${title} senare.`,
      continueLaterNoTitleText:
        'Vi har skickat dig ett e-postmeddelande med länken så att du kan fortsätta utvärderingen av kandidaten i intervjun senare.',
      closeEvaluation: 'Stäng',
      continueEvaluation: 'Fortsätt utvärderingen',
      confirmationTitle: 'Avsluta utvärderingen?',
      confirmationMessage:
        'Är du säker på att du vill avsluta utvärderingen? Du kommer inte att kunna göra ytterligare ändringar efter att den har avslutats.',
      previousStepButton: 'Gå till föregående',
      nextStepButton: 'Gå till nästa',
      selectAtLeastOneEvaluator: 'Vänligen välj minst en utvärderare.',
      interviewInsights: 'Intervjusinsikter',
    },

    interviewFormSetup: {
      title: 'Intervjuformulärets sammansättning',
      notAsked: 'Inte bett',
      optional: 'Frivillig',
      required: 'Krävs',
      name: 'Namn',
      email: 'E-postadress',
      phoneNumber: 'Telefonnummer',
      city: 'Stad',
      attachments: 'Bilagor',
      links: 'Länkar',
      attachmentsDescription: 'Beskrivning av bilagor',
    },

    interviewRow: {
      invites: 'Inbjudningar',
      responses: 'Svar',
      endTime: 'Öppen fram tills',
      createdAt: 'Skapad datum',
      timedTitle: 'Tidsinställd intervju',
      newVideos: 'Nya svar',
    },

    interviewGuideRow: {
      createdAt: 'Skapad datum',
      owner: 'Ägare',
      language: 'Språk',
    },

    interviewRoundRow: {
      createdAt: 'Skapad datum',
      owner: 'Ägare',
      language: 'Språk',
      endTime: 'Öppen till',
      status: 'Status',
    },

    interviewGuideStep: {
      noSteps: 'Inga delar tillagda ännu.',
      reorder: 'Ordna om delar',
      titleLabel: 'Delens titel',
      titlePlaceholder: 'Lägg till en titel för delen',
      interviewContentPlaceholder: 'Delens innehåll då intervjun pågår',
      evaluationContentPlaceholder: 'Delens innehåll efter intervjun',
      interviewTabLabel: 'Frågor',
      evaluationTabLabel: 'Utvärdering',
      stepTimeLabel: 'Delens tidsbruk (minuter)',
      stopReordering: 'Avsluta ordningen av delar',
      delete: 'Ta bort del',
      add: 'Lägg till nytt del',
    },

    introduction: {
      batchIntroduction: count => `Introducerat till ${count} mottagare`,
    },

    jobAdRow: {
      newApplications: 'Ogranskade',
      applications: 'Ansökningar',
      publishTime: 'Publiceringsdatum',
      endTime: 'Öppen till',
    },

    positionStatus: {
      open: date => (date ? `fram tills ${date}` : ''),
      hidden: date => (date ? `fram tills ${date}` : ''),
      filled: () => 'status: Ifylld',
      cancelled: () => 'status: Annullerad',
      closed: () => 'status: Stängd',
      draft: () => 'status: Stängd (utkast)',
      unpublished: () => 'status: Utkast',
      publishTime: 'Publiceringsdatum',
    },

    jobAdTeaser: {
      add: 'Skapa ny ansökan',
      noApplications: 'Inga ansökningar ännu.',
      preview: 'Förhandsgranska platsannonsen här',
      placeholder: {
        first: 'Du kan boosta och marknadsföra din jobbannons med direkta länkar till din jobbportal',
        second: 'eller så kan du marknadsföra detta bestämda jobb med en direkt länk',
        third: 'Och glöm inte att alla dessa inte är längre bort än bara en knapp i titelbalken ovan.',
      },
    },

    list: {
      total: count => `Totalt: ${count}`,
      selectAll: 'Välj alla',
      resetSelection: count => (count > 0 ? `Återställ val (${count})` : 'Återställ val'),
    },

    liveRow: {
      finished: 'Upphöra',
      coming: 'På kommande',
      active: 'Pågående',
      titleFallback: 'Live interview',
      startTime: 'Start time',
      interviewers: 'Interviewers',
      candidates: 'Candidates',
      status: 'Status',
    },

    loginForm: {
      email: 'E-postadress',
      password: 'Lösenord',
      submit: 'Logga in till tjänsten',
      changePasswordInfo:
        'Lösenordet är nu ändrat! Logga in med ditt nya lösenord.',
      error: {
        email: {
          isRequired: 'Var god, ange din e-postadress.',
          isEmail: value => (value ? `${value} är inte en giltig e-postadress.` : ''),
        },
        password: {
          isRequired: 'Var god, ange ett lösenord.',
        },
        login: {
          incorrect: 'Inloggningen misslyckades.',
          deactivated:
            'Användarkontot har avaktiverats. Kontakta din organisations administratör hos Recright.',
          tries: 'För att skydda din säkerhet begränsar vi antalet nya försök att ange lösenordet. Försök ingen om en stund eller återställ ditt lösenord.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Organisationens logo här',
      removeLogo: 'Ta bort logotyp',
      addLogo: 'Välj logotyp',
    },

    modalAccountType: {
      title: 'Ändra kontotyp?',
      confirm: 'Ändra',
      cancel: 'Avbryt',
    },

    modalApplicationAllInvited: {
      title: 'Bjud in kandidater',
      description: 'Alla valda kandidater har redan bjudits in till intervjun',
    },

    modalApplicationIntroduce: {
      title: 'Presentera kandidaterna',
      description: 'Ange presentationmottagarnas e-postadresser nedan',
      titlePlaceholder: 'Rubrik',
      contentPlaceholder: 'Meddelandets innehåll',
      emailsPlaceholder: 'Mottagarnas e-postadresser',
      namePlaceholder: 'Namn',
      cancel: 'Avbryt',
      sendIntroductions: 'Skicka presentationerna',
    },

    modalApplicationInvite: {
      title: 'Väljer videointervju',
      description: 'Vill du skapa en ny videointervju eller använda en befintlig?',
      createNew: 'Skapa ny intervju',
      videoInterviewDescription: 'Bjud in en kandidat till en videointervju och möt den verkliga personen bakom CV:n!',
      error: {
        selectInterview: 'Välj intervju.',
      },
      cancel: 'Avbryt',
      close: 'Stäng',
      continue: 'Fortsätt',
    },

    modalApplicationReInvite: {
      title: 'Återsänd inbjudan till den sökande',
      description: 'Välj intervju, dit du vill bjuda in kandidaten pånytt.',
      info: 'Du kan inte skicka inbjudan till en intervju som är stängd.',
      submit: 'Skicka inbjudan pånytt',
      cancel: 'Avbryt',
    },

    modalApplicationMessage: {
      title: 'Skicka meddelande till utvalda kandidater',
      description: 'Vilken typ av meddelande vill du skicka?',
      email: 'Skicka e-post',
      videoMessage: 'Skicka videomeddelande',
      close: 'Stäng',
      cancel: 'Avbryt',
      continue: 'Fortsätt',
      sendEmail: 'Skicka meddelande',
      emailTitle: 'Skicka e-post till kandidaterna',
      emailDescription: 'Skriv e-postmeddelande till de utvalda kandidaterna',
      videoTitle: 'Lägg till nytt videoklipp',
      titlePlaceholder: 'Rubrik',
      contentPlaceholder: 'Skriv ditt meddelande här',
      candidates: 'kandidater',
      selectedCandidates: 'Mottagare',
      emailSent: 'E-postmeddelandet skickades!',
      answerable: 'Videoklippet kan besvaras',
      signature: 'Med vänlig hälsning,',
    },

    modalAtsTeaser: {
      title: 'Publicera öppna positioner och hantera rekryteringsprocessen',
      content: 'Välj den information du vill fråga från kandidaterna och publicera din öppna position. Vi upprätthåller din karriärsida och du kan enkelt dela länken någonstans. Din arbetsgivarbild förbättras med effektiv kandidatkommunikation.',
      cancel: 'Avbryt',
      confirm: 'Ja, kontakta mig',
      greetings: 'Meddelandet har skickats.',
    },

    modalFeedbackPulseTeaser: {
      title: 'Nyfiken på hur kandidater betygsatt rekryteringsprocessen?',
      content: 'I slutet av varje rekryteringsprocess har alla kandidater möjlighet att betygsätta sin upplevelse. Ditt helhetsbetyg grundar sig på medeltalet av samlad respons.',
      cancel: 'Avbryt',
      confirm: 'Ja, kontakta mig',
      greetings: 'Meddelande skickat.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Skicka meddelande till utvalda kandidater' : 'Skicka ett meddelande till kandidaten'),
      description: 'Vilken typ av meddelande vill du skicka?',
      recipients: count => `Meddelandet skickas till ${count} mottagare`,
      email: 'Skicka e-post',
      videoMessage: 'Skicka videomeddelande',
      library: 'Välj från biblioteket',
      close: 'Stäng',
      cancel: 'Avbryt',
      continue: 'Fortsätt',
      resendInvitation: 'Skicka inbjudan pånytt',
      resendInvitationSms: 'Sänd inbjudan på nytt med sms',
      sms: 'Sänd sms-meddelande',
      sendEmail: 'Skicka meddelande',
      emailTitle: count => (count > 1 ? 'Skicka e-post till kandidaterna' : 'Skicka ett mail till kandidaten'),
      emailDescription: 'Skriv e-postmeddelande till de utvalda kandidaterna',
      videoTitle: 'Lägg till nytt videoklipp',
      libraryTitle: count => (count > 1 ? 'Skicka videoklipp till kandidaterna' : 'Skicka video till kandidaten'),
      titlePlaceholder: 'Rubrik',
      contentPlaceholder: 'Skriv ditt meddelande här',
      candidates: 'kandidater',
      selectedCandidates: 'Mottagare',
      emailSent: candidates => `${candidates} e-postmeddelanden skickades!`,
      answerable: 'Videoklippet kan besvaras',
      successMessage: candidates => `${candidates} videoklipp skickades!`,
      scheduledInterview: 'Sänd inbjudan till schemalagt möte',
      reScheduledInterview: 'Omboka möte',
      record: 'Spela in',
      upload: 'Ladda',
      scheduledInterviewDescription: 'Låt kandidaten boka ett möte med dig enligt din angivna anträffbarhet.',
      reScheduledInterviewDescription: 'Omboka möte med kandidat. Observera att tidigare mötesinbjudningar avbokas',
      required: '* Fälten markerade med en asterisk är obligatoriska.',
      tooManyRecipients: count => `För många mottagare valda. Det högsta antalet är ${count}.`,
      tooLongMessage:
        'Meddelandet är för långt. Kontrollera teckenräknaren. Obs: Vissa specialtecken minskar den maximala längden på meddelandet.',
    },

    modalEditIntroduceBatches: {
      title: 'Introduktionerna',
      description: ' Här kan du hantera uppgiftsintroduktionerna. Du kan förlänga giltighetstiden på introduktionslänkarna, ta bort personer från introduktionsteamet eller radera hela introduktionsteamet.',
      noBatches: 'Inga introduktioner',
      descriptionWithCount: (candidateNames) => `Introducerad ${candidateNames} och %COUNT_LINK% andra till följande personer:`,
      descriptionWithoutCount: candidateNames => `Introducerad ${candidateNames} till följande personer:`,
      expires: 'Giltig',
      email: 'E-postadress',
      actions: 'Åtgärder',
      close: 'Stäng',
      visited: 'Har besökt',
      extendLinkText: 'Fortsätt',
      extendTo: date => `Fortsätt till ${date}`,
      deleteBatch: 'Ta bort introduktionsteamet',
      deleteBatchWarning: 'Är du säker på att du vill radera introduktionsteamet?',
      maxExpirationDate: 'Länkens giltighetstid är maximalt 10 dagar från och med idag.',
      extendedMessage: newExpirationDate => `Presenteringslänkens giltighetstid har förlängts till och med den ${newExpirationDate}!`,
      url: 'URL',
      introductionLink: 'Länk',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Uppgift om inbjudans avsändare',
      customReplyToSubtitle:
        'Här kan du redigera namnet och svarsadressen för avsändaren av inbjudan. Om fältet lämnas tomt används namnet och adressen för den användare som skickar inbjudan.',
      customReplyToEmail: 'E-postadress för svar på inbjudan till intervju',
      customReplyToName:
        'Namnet som kommer att visas som avsändare på inbjudan till intervju',
      saveSuccess: 'Inställningarna sparades!',
    },

    modalEditInvitationMessage: {
      saveTemplate: 'Spara som inbjudningsmeddelande till denna intervju',
      title: 'Redigera intervjuinbjudan',
      info: 'Välj den intervju du vill redigera',
      close: 'Stäng',
      templateSaved: 'Meddelandet sparades nu som en mall för denna intervju.',
      templateOptionsLabel: 'Select template',
      interviewRound: {
        title: 'Redigera inbjudningsmeddelandet för denna intervjurunda',
        submitButtonText:
          'Spara mall för inbjudningsmeddelandet till intervjurundan',
        templateSaved:
          'Mallen för intervjurundans inbjudningsmeddelande sparades',
      },
    },

    modalEditStages: {
      title: 'Ändra på rekryteringsfaserna',
      info: 'Du kan editera, lägga till, radera eller omorganisera rekryteringsfaser. Lägg märke till att det inte är möjligt att radera en fas ifall den innehåller kandidater.',
      addNewStage: 'Lägg till ny rekryteringsfas',
      removeDisabled: 'Det är inte möjligt att radera en fas, då fasen innehåller kandidater.',
      error: 'Fasen har redan laggts till.',
      done: 'Klar',
      save: 'Spara',
      close: 'Stäng',
      confirm: 'Bekräfta',
      cancel: 'Annullera',
      delete: 'Radera',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Dolda annonser',
      modalDescription: name => `Kontrollera vilka annonser användaren ${name} ser.`,
      hiddenFrom: name => `Annonser dolda från användaren ${name}`,
      noResults: 'Inga resultat',
      jobAdLabel: 'Arbetsannons',
      interviewLabel: 'Video intervju',
      noPositions: 'Inga annonser',
      remove: 'Ta bort',
      searchInfo: 'Bläddra för att dölja annonser',
      hide: 'Dölj',
      close: 'Stäng',
      searchPlaceholder: 'Leta enligt annonsens titel eller läge',
      total: total => `${total} annonser totalt`,
      labels: {
        title: 'Titel',
        location: 'Läge',
        time: 'Skapelsedatum',
        actions: 'Åtgärder',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Ta bort användaren från denna organisation',
      modalDescription: name =>
        `Användaren ${name} är en extern användare och kommer att tas bort endast från denna organisation. Efter att användaren raderats kommer användaren fortfarande att ha åtkomst till andra organisationer inom Recright.`,
      modalExplanation: name =>
        `Användaren kommer inte längre att ha åtkomst till befattningar inom denna organisation. Du kommer att ärva åtkomsten till de befattningar för vilka ${name} var den enda rekryteraren.`,
      adminInRecruitmentTeam: name =>
        `Befattningar där användaren ${name} var en del av rekryteringsteamet:`,
      noResults: 'Inga resultat',
      noPositions: 'Inga annonser',
      jobAdLabel: 'Arbetsannons',
      interviewLabel: 'Video intervju',
      total: total => `${total} annonser totalt`,
      close: 'Stäng',
      remove: 'Ta bort från organisation',
      removeUserConfirmMessage: 'Ta bort användare',
      removeUserConfirmContent:
        'Är du säker på att du vill ta bort användaren från denna organisation?',
      labels: {
        title: 'Titel',
        time: 'Skapelsedatum',
        creator: 'Ny ägare av befattning',
      },
      otherAdmin: 'Andra administratörer i rekryteringsteamet',
    },

    modalInterviewRoundSelectInviteType: {
      title: 'Välj schemaläggningstyp',
      subtitle:
        'Välj om du själv vill välja intervjutid eller om kandidaten ska välja tid.',
      regularTitle: 'Vanlig',
      regularDescription: 'Du väljer själv tid för intervjun.',
      scheduledTitle: 'Kandidaten väljer tiden',
      scheduledDescription:
        'Kandidaten väljer tid för intervjun baserat på intervjuarnas tillgänglighet.',
      cancel: 'Avbryt',
      continue: 'Fortsätt',
    },

    modalInterviewRoundInvite: {
      nameEmailLabel: 'Namn/E-post',
      startTimeLabel: 'Intervjutid',
      title: 'Schemalägg intervju',
      submit: 'Bjud in kandidater',
      selectedCandidates: 'Valda kandidater',
      savedTemplate: 'Sparad mall för inbjudningsmeddelandet',
      templateChangedInfo:
        'Du har redigerat inbjudningsmeddelandet. Denna ändring skickas till denna mottagargrupp, men sparas inte som mall för intervjurundan.',
      saveTemplate: 'Spara som intervjurundans inbjudningsmall',
      templateSaved:
        'Meddelandet har nu sparats som mall för denna intervjurunda.',
    },

    interviewRoundInviteModalContent: {
      subjectPlaceholder: 'Ämne',
      messagePlaceholder: 'Meddelande',
      namePlaceholder: 'Namn',
    },

    modalReschedule: {
      title: 'Omboka intervju',
      submit: 'Skicka ombokningsmeddelande',
      rescheduleConfirmBody: 'sÄr du säker på att du vill boka om denna intervju?',
    },

    modalPersonStage: {
      new: 'Ny',
      hired: 'Anställd',
      proceed: 'Gå vidare',
      personalinterview: 'Personlig intervju',
      withdrawn: 'Borttagen',
      scheduledinterview: 'Schemalagd intervju',
      rejected: 'Avvisad',
      videointerviewed: 'Videointervju',
      change: 'Överför kandidater från rekryteringsfasen till en annan',
      info: 'Flytta valda kandidater till det andra steget. Denna information är inte synlig för kandidaterna.',
      changedInfo: stage => `Nu när du har flyttat kandidaterna till rekryteringsfasen "${stage}", låt dem veta! Skicka dem ett mail eller ett videoklipp.`,
      done: 'Förflytta',
      cancel: 'Avbryt',
      changed: 'Fantastiskt!',
      close: 'Stäng',
      reopenProcessConfirmPlural: 'Är du säker på att du vill flytta dessa kandidater från "Borttagen" och återföra dem till rekryteringsprocessen? Efter att kandidaterna har bekräftat kan de återigen svara på alla intervjuer som de inte ännu har slutfört.',
      withdrawConfirmPlural: 'Är du säker på att du vill ta bort dessa kandidater från rekryteringsprocessen? När kandidaterna är borttagna kan de inte längre svara på några intervjuer som de blir inbjudna till.',
      changeSingle: 'Flytta kandidaten till ett annat stadie',
      infoSingle: ' Flytta kandidaten till ett annat stadie. Denna information är inte synlig till kandidaten.',
      changedInfoSingle: stage => `Nu när du har flytta kandidaten till stadiet "${stage}" låt dom veta om det! \n\n Skicka ett mail eller ett videomeddelande.`,
    },

    modalInterviewAdd: {
      timedTitle: 'Tidsinställd intervju',
      timedDescription: 'Kandidater registrerar sina svar på intervjufrågorna inom en begränsad och förinställd tidsperiod. Du kan ställa in tiden till både svar och förberedelse för varje fråga.',
      title: 'Skapa ny intervju',
      description: 'Välj vilken typ av intervju du vill skapa',
      friendlyTitle: 'Videointervju',
      friendlyDescription: 'Kandidaterna kan spela in så många försök som de vill och det finns ingen tidsgräns för försöken.',
      cancel: 'Avbryt',
      continue: 'Fortsätt',
    },


    modalLiveInterviewAdd: {
      title: 'Skapa ny liveintervju',
      description: 'Välj vilken typ av liveintervju du vill skapa.',
      basicTitle: 'Normal liveintervju',
      basicDescription: 'Tidpunkten för liveintervjun väljs av dig.',
      scheduledTitle: 'Schemalagd liveintervju',
      scheduledDescription:
        'Tidpunkten för liveintervjun väljs av kandidaten utifrån din tillgänglighet.',
      cancel: 'Avbryt',
      continue: 'Fortsätt',
    },

    modalInterviewPublish: {
      modalTitle: 'Publicerings inställningar',
      publicTitle: 'Offentlig intervju',
      publicDescription: 'Denna intervju har en offentlig sida med en adress som du kan dela i din jobbannonser och på ditt företags webbsida. Alla som är intresserade av jobbet kan se dina frågor och sedan besluta om att delta. Du får det vanliga meddelandet när svar börjar komma in.',
      publishButton: 'Skapa offentlig länk',
      unPublishButton: 'Ta bort den offentliga länken',
      title: 'Inbakad intervju',
      description: 'Intervjuer med en fråga kan smidigt inbäddas till företagets hemsida. Kandidaten sätter sin e-post address, spelar in ett video-svar och tillsätter frivilligt sin LinkedIn-profil eller övrig information via en länk.',
      descriptionMultiple:
        'Integrera sömlöst en videointervju i din jobbannons eller på företagets hemsida. Kandidater anger sin e-postadress, spelar in videosvar och har möjlighet att inkludera en länk till sin LinkedIn-profil för ytterligare information.',
      embedNotification: 'Man kan inte fråga efter annat information med en intervju som är inbäddad till hemsidan.',
      embedButton: 'Skapa inbäddningskod',
      unEmbedButton: 'Ta bort inbäddningskoden',
      close: 'Stäng',
      oneError: 'En inbäddad intervju kan bara innehålla en fråga. Var vänlig och radera de övriga frågorna för att kunna använda den inbäddade intervjun.',
      subscriptionNeeded: 'Du behöver en aktiv prenumeration för att publicera din intervju.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Presentera kandidaterna' : 'Presentera kandidaten'),
      descriptionFirst: 'Med introduktionsfunktionen kan du presentera utvalda sökande till exempel till din förman.',
      descriptionSecond: 'Mottagaren av introduktionen behöver inte skapa ett ID, men ser bara de valda sökandena. Lägg till e-postadresserna till mottagarna nedan. Välj vilken information du vill att mottagarna ser från sökandena. Introduktionernas mottagare kommer bara att se de vald information. Om du väljer "Vitsord" eller "Kunskap och egenskaper", mottagaren av introduktionerna kan ge sin egen bedömning och ser också genomsnittet av givna betyg.',
      descriptionThird: 'Du har också möjlighet att skydda introduktionsteamet med ett lösenord som begärs från mottagarna av introduktionerna när de vill se de presenterade sökandena.',
      descriptionFourth: days =>
        `Introduktion är giltig i ${days} dygn efter avsändning. Du kan förlänga giltighetstiden under inställningarna för introduktioner. Du hittar dessa inställningarna genom att klicka på "Redigera introduktioner" under menyn "Redigera".`,
      titlePlaceholder: 'Rubrik',
      contentPlaceholder: 'Meddelandets innehåll',
      emailsPlaceholder: 'Mottagarnas e-postadresser',
      namePlaceholder: 'Namn',
      cancel: 'Avbryt',
      sendIntroductions: 'Skicka presentationerna',
      selectedCandidates: count => `${count} kandidater som valts ut att presenteras`,
      successMessage: (candidates, introducees) => `${candidates} kandidater presenterad för ${introducees} personer`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} Kandidaten är presenterad till ${introducees} personer. ${isInTeam} hördes redan till rekryteringsteamet.`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'hör redan till rekryteringsteamet.' : 'hör redan till rekryteringsteamet.'),
      name: 'Namn',
      email: 'E-postadress',
      phone: 'Telefonnummer',
      city: 'Stad',
      coverLetter: 'Följebrev',
      attachments: 'Bilagor',
      links: 'Länkar',
      competencies: 'Kompetens och egenskaper',
      rating: 'Poäng',
      videoResponses: 'Videosvar',
      comments: 'Kommentarer',
      informationsHeader: 'Välj den information som ska presenteras',
      messageHeader: 'Presentationsmeddelande',
      copyToClipboard: 'Kopiera koden till urklippet',
      usePasscodeText: 'Skydda introduktionsteamet med åtkomstkod',
      passcode: 'Lösenord',
      generatePasscode: 'Skapa nytt lösenord',
      selectAll: 'Välj alla',
      resetSelection: 'Återställ val',
      copySuccess: 'Acceskoden kopierad!',
      close: 'Stäng',
      introduceLinkButton: 'Skapa länk',
      introduceLink: 'Presentera med en länk',
      introduce: 'Presentera',
      formError: 'Fel',
      linkCreationError: 'Fel när en länk skapades',
      link: 'Länk',
      aiInsights: 'AI insikter',
      transcripts: 'Transkript',
      continue: 'Fortsätt',
    },

    modalInterviewInvite: {
      senderInfo: 'Inbjudningar skickas från invitations@recright.com e-postadress.',
      replyToEmail: 'E-postadress för svar på inbjudan till intervju',
      replyToName:
        'Namnet som kommer att visas som avsändare på inbjudan till intervju',
      replyToInfo:
        'Du kan redigera dessa fält på sidan där intervjun redigeras.',
      notAnswerable: 'Du kan inte bjuda in användare till sluten intervju eller intervju som inte har lyder frågor.',
      title: 'Bjud in kandidater',
      description: 'Mata in alla kandidaters e-postadresser.',
      description2: 'När de svarar, kommer du att få en e-postanmälan. Observera, att när du har bjudit kandidater kan du inte längre lägga till frågor',
      smsDescription: 'Efter att du har sänt e-postinbjudningar kan du sända sms-meddelande till kandidaterna',
      addressesPlaceholder: 'Kandidaternas e-postadresser',
      submit: 'Skicka inbjudningar',
      cancel: 'Avbryt',
      close: 'Stäng',
      templateChangedInfo: 'Du har redigerat inbjudningsmeddelandet. Denna ändring kommer att skickas till de mottagare du väljer, men sparas inte i intervjumallen.',
      templateSaved: 'Meddelandet sparades som en intervjumall.',
      inviteInfo: (newInvitees, stage) => `Inbjudan till intervjun skickas till ${newInvitees} sökanden av valda sökanden. Alla valda kandidater flyttas till nästa fas "${stage}".`,
      invitesSent: (success, failed) => (failed > 0 ? `${success} inbjudningar skickas och ${failed} redan inbjuden.` : `${success} inbjudningar skickas.`),
      subscriptionNeeded: 'Du behöver ha en aktiv prenumeration för att bjuda in kandidater.',
      saveTemplate: 'Spara som inbjudningsmeddelande till denna intervju',
      rrTemplateOptionLabel: 'Recright standardmall',
      interviewTemplateOptionLabel: 'Sparad mall för inbjudningsmeddelandet',
      interviewRoundTemplateOptionLabel: 'Sparad mall för inbjudningsmeddelandet',
      templateOptionsLabel: 'Välj mall',
    },

    modalInterviewInviteSms: {
      title: 'Inbjudningarna har sänts',
      description: count => `${count} inbjudningar har sänts`,
      description2: 'Vill du även sända ett sms-meddelande till de inbjudna kandidaterna?',
    },

    modalSmsMessage: {
      description: count => `Meddelandet skickas till ${count} mottagare`,
      phonePlaceholder: 'Telefonnummer',
      title: 'Sänd sms-meddelande',
      invitationTitle: 'Sänd inbjudan med sms',
      resendInvitationTitle: 'Sänd inbjudan på nytt med sms',
      missingInvitationDescription: count => `${count} mottagare saknar inbjudan. Vänligen skriv inbjudningsmeddelandet nedan.`,
      missingPhone: count => `${count} mottagare saknar ett giltigt mobilnummer.`,
      missingPhone2: 'Vänligen lägg till mobilnumren i fälten nedan.',
      successMessage: count => `${count} sms-meddelanden har skickats.`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} sms-meddelanden har skickats. ${failedCount} sms-meddelanden kunde inte skickas.`,
      failedMessage: 'Det gick inte att sända sms-meddelande till någon av mottagarna',
      recipientsNotFound: 'Ett oväntat fel uppstod. Vänligen försök igen senare och om problemet kvarstår, kontakta vår support.',
    },

    modalInterviewStatus: {
      change: 'Ändra intervjustatus',
      changed: 'Intervjustatusen är ändrad',
      changeRoundStatus: 'Change interview round status',
      roundStatusChanged: 'Interview round status changed',
      changedInfo: 'Intervjustatusen är ändrad. Kom ihåg att informera kandidaterna om besluten!',
      info: 'Välj den nya statusen för intervjun.',
      open: 'Öppen',
      closed: 'Stängd',
      done: 'Klar',
      close: 'Stäng',
      endTimeInPast: model => model === 'interview' ?
        'Intervjun har en deadline som är i det förflutna. När du öppnar intervjun kommer deadlinen att raderas. Du kan lägga till en ny deadline från ' :
        'This interview round has an end date that is in the past. When you open the interview round the end date will be removed. You can set a new end date from the ',
      endTimeInPastLink: 'editerings sidan',
      cancel: 'Avbryt',
    },

    modalInterviewSelectForEdit: {
      title: 'Redigera uppgifterna',
      info: 'Välj den intervju du vill redigera',
      cancel: 'Avbryt',
      done: 'Klar',
      error: {
        selectInterview: 'Välj intervju.',
      },
    },

    modalJobAdPreview: {
      title: 'Förhandsgranska jobb',
      description: 'Här ser du hur arbetsannonsen ser ut för kandidaten.',
      description2: 'Notera att språket i förhandsgranskningen inte nödvändigtvis är samma som språket i arbetsannonsen.',
      close: 'Stäng',
      back: 'Tillbaka',
    },

    modalJobAdStatus: {
      change: 'Ändra jobbstatus',
      changed: 'Jobbstatusen är ändrad',
      changedInfo: 'Jobbstatusen är ändrad. Kom ihåg att informera kandidaterna om besluten!',
      info: 'Välj den nya statusen för jobbet. Genom att sätta statusen till "Ifylld" eller "Annullerad" kommer du att vägledas genom de nödvändiga stegen för att välja de anställda personerna och/eller att skicka de återstående "Nej tack"-meddelandena',
      open: 'Öppen',
      filled: 'Ifylld',
      cancelled: 'Annullerad',
      done: 'Klar',
      close: 'Stäng',
      draft: 'Stängd (utkast)',
      unpublished: 'Utkast',
      closed: 'Stängd',
      hidden: 'Dold',
      openDescription: 'Jobbannonsen är publicerad fram till',
      filledDescription: 'Stäng jobbannonsen då jobbet har blivit tillsatt.',
      cancelledDescription: 'Stäng jobbannonsen eftersom rekryteringsprocessen har avbrutits.',
      closedDescription: 'Jobbannonsen är stängd. Jobbannonsen är inte åtkomlig eller synlig för kandidaterna.',
      hiddenDescription: 'Dölj jobbet från karriärsidan. Jobbet är endast åtkomligt via den direkta länken:',
      unpublishedDescription: 'Annonsen är inte publicerad. Jobbannonsen är inte åtkomlig eller synlig för kandidaterna.',
      cancel: 'Annulera',
    },

    modalJobPositionTeam: {
      addAnother: 'Lägg till fler användare genom att lägga till deras e-postadresser',
      team: 'Rekryteringsteam',
      info: 'Du kan lägga till kolleger eller andra användare som ska granska och evaluera kandidaterna',
      newMembersMsg: 'Nya teammedlemmar utan befintligt konto hos Recright kommer att läggas till i verksamheten där den aktuella befattningen tillhör.* Om användarens e-postdomän inte motsvarar domänen som är kopplad till organisationen, tilldelas användaren endast de lägsta användarrättigheterna. Användarrättigheterna kan ändras senare av administratörer som har tillgång till användarhanteringen.',
      asteriskSymbol: '*',
      currentTeam: 'Nuvarande team',
      done: 'Klar',
      remove: 'Ta bort',
      submit: 'Lägg till teammedlemmar',
      cancel: 'Annulera',
      selfRemovedMessage: 'Du har raderat dig från rekryteringen.',
      successMessage: count => `${count} medlemmar har lagts till i rekryteringsteamet.`,
      errors: {
        duplicate: 'E-posten har redan blivit tillagd.',
        duplicateMultiple: 'Team-medlem/-ar finns redan med en eller fler tillagda e-postadresser.',
        isEmail: 'E-postadressen är ogiltig,',
        isEmailMultiple: 'Ogiltiga e-postadresser har hittats.',
        isRequired: 'Obligatoriskt fält.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `Är du säker på att du vill göra en kopia på ${context === 'jobAd' ? 'jobbet' : 'intervjun'} "${position.title}"?`,
      admins: 'Vill du också kopiera rekryteringsteamet?',
      done: 'Kopiera',
      cancel: 'Annulera',
    },

    modalVideos: {
      title: 'Videobibliotek',
      yourVideos: 'Dina videon',
      companyVideos: 'Organisationens videon',
      add: 'Lägg till',
      done: 'Lägg till videoklipp',
      cancel: 'Avbryt',
      selectedVideos: 'Valda videor',
      clearAll: 'Rensa alla',
    },

    videoCollectionBrowser: {
      allVideos: 'Alla videor',
      noCollections: 'Inga samlingar',
      videoCountSingular: 'video',
      videoCountPlural: 'videor',
      folderView: 'Mappvy',
      listView: 'Listvy',
      sort: {
        createdAt: 'Skapad datum',
        title: 'Titel',
      },
    },

    modalUsersAdd: {
      title: 'Bjud in användare',
      languageDescription: 'Dessa användare kommer att ha följande språk:',
      permissionsDescription: 'Dessa användare kommer att ha följande rättigheter:',
      emailsPlaceholder: 'Lägg till användarens e-postaddress',
      seeAllPositions: 'Se alla annonser',
      createJobPositions: 'Lägg till ny annons',
      createInterviews: 'Skapa intervju',
      account: 'Ändra företagsinfo',
      billing: 'Fakturering',
      reporting: 'Rapportering',
      editUsers: 'Ändra användare',
      default: 'Företagets standard rättigheter',
      cancel: 'Annullera',
      submit: 'Bjud in användare',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Företagets standard rättigheter:',
      description: 'Alla nya användare som registrerar sig till detta företag har automatiskt standard rättigheter.',
      seeAllPositions: 'Se alla annonser',
      createJobPositions: 'Lägg till ny annons',
      createInterviews: 'Skapa intervju',
      account: 'Ändra företagsinformation',
      billing: 'Fakturering',
      reporting: 'Rapportering',
      editUsers: 'Redigera användare',
      cancel: 'Annulera',
      submit: 'Spara',
    },

    modalOtherApplications: {
      title: 'Kandidaten i andra positioner',
      header: 'Här är listan av samma kandidat i andra andra positioner',
      close: 'Stäng',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Se alla annonser',
        createJobPositions: 'Lägg till ny annons',
        createInterviews: 'Skapa intervju',
        account: 'Ändra företagsinformation',
        billing: 'Fakturering',
        reporting: 'Rapportering',
        editUsers: 'Redigera användare',
        default: 'Standard rättigheter',
      },
    },

    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelectedRegular: 'Välj minst en intervjuare',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnected:
          "The user's calendar is not connected to Recright, and their availability information cannot be accessed.",
        interviewerCalendarNotConnected2:
          "They'll receive an email with scheduling information and instructions on how to connect their calendar to Recright.", singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Omboka möte',
        confirmRescheduleContent: 'Några mottagare har redan ett möte inbokat. Vill du skicka nya inbjudningar? Denna åtgärd kommer att ersätta deras redan inbokade möte.',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      save: 'Spara',
      cancel: 'Avbryt',
      addToCollection: 'Lägg till i samling',
      title: 'Redigera video',
      success: 'Ändringarna i videon har sparats!',
      error:
        'Det gick inte att spara ändringarna. Försök igen senare och kontakta vår support om problemet kvarstår.',
    },

    noResults: {
      description: 'Din lista verkar vara tom. Ifall du använder mer än en filter för listan, försök att minska antalet filter',
    },

    notifications: {
      notifications: 'Meddelanden',
    },

    notificationsSubscribeButton: {
      subscribe: 'Prenumerera',
      subscribed: 'Prenumererat',
      unsubscribe: 'Annulera',
    },

    onboardTutorial: {
      ui: {
        back: 'Tillbaka',
        close: 'Stäng',
        last: 'Ok!',
        next: 'Nästa',
        skip: 'Avsluta',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First thing first. Let\'s connect your calendar, so you can schedule meetings with candidates! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Välkommen till Recright',
          text: 'Vi kommer att leda dig i användningen av vårt program med interaktiv handledning. Med att trycka på pulsen ser du en handledning till den rådande funktionen. Du kan aktivera handledningen igen när som helst med att trycka på ditt namn och “Visa handledning”.',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Skapa en ny arbetsplats',
          text: 'Skapa och publicera jobbannonsen här',
          selector: '.joyride--add-job-ad',
          position: 'bottom-left',
        },
        {
          title: 'Skapa en ny videointervju',
          text: 'Skapa en ny videointervju och bjud in sökanden här.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Inställningar',
          text: 'Ändra inställningar till ditt konto härifrån, definiera karriärsajtens utseenden och address, hantera din videobibliotek samt ändra språket på sajten. Härifrån kan du även sätta handledningen på pånytt.',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },

      ],
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Tillfoga bakgrundsbild och logo',
          text: 'Tillfoga bakgrundsbild och logo till annonsen. Den optimala storleken för bakgrundsbilden är 1440 x 320 pixlar och den syns till sökaren i annonsens övre del.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Rubrik, läge, publiceringsdatum, sista ansökningsdag',
          text: 'Skriv jobbtitel, plats, arbetsplatsens läge, arbetsplatsens publiceringsdatum samt sista ansökningsdagen. Ifall du lämnar sista ansökningsdagen tom, är arbetsansökan öppen tillsvidare.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Beskrivning av arbetsplatsen',
          text: 'Skriv beskrivningen för arbetsplatsen här. Skriv vad det är som söks, vad kraven är och vad ni erbjuder.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Arbetsgivarvideo',
          text: 'Framhäva ert företags kultur och förbättra arbetsgivar intrycket med att tillsätta en arbetsgivarvideo till annonsteksten.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Information som begärs med ansökningsformuläret',
          text: 'Välj den information du vill veta om sökarna. Informationen kan vara frivillig eller obligatorisk.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Intervjufråga',
          text: 'Ställ en intervjufråga redan i ansökningsskedet för att se personen bakom ansökan. Det här är även perfekt chans att hälsa ansökarna.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Tillfoga bakgrundsbild och logo',
          text: 'Tillfoga bakrundsbild och logo till intervjun. Den optimala storleken för bakgrundsbilden är 1440 x 320 pixlar och den syns till sökaren i annonsens övre del.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Rubrik, giltig',
          text: 'Namnge videointervjun och ange ett sista datum för svarandet. Ifall du vill lämna den öppen tillsvidare, lämna fältet “giltig” tom.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Information som begärs med ansökningsformuläret',
          text: 'Välj den information du vill veta om sökarna. Informationen kan vara frivillig eller obligatorisk',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Intervjufrågorna',
          text: 'Spela in, ladda upp eller välj intervjufrågorna från biblioteket. Du kan även skapa textfrågor ifall du inte har möjligheten att använda videon. Sökaren svarar dock alltid med videon.',
          selector: '.joyride--interview-video-questions',
          position: 'top',
        },
      ],
      createdJobAd: [
        {
          title: 'Arbetsplatsens funktioner',
          text: 'Här kan du återgå till att redigera anmälan, ändra dess status och bjuda in dina kollegor för att utvärdera ansökningarna.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Publicering av annonsen',
          text: 'Dela jobbannonser på sociala kanaler för att få maximal synlighet för det.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Videointervjuns funktioner',
          text: 'Här kan du återvända för att redigera intervjun, ändra dess status och bjuda in dina kollegor för att utvärdera sökandena.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Publicering av videointervju',
          text: 'Bjud in sökande till en intervju, eller gör intervjun allmän och dela den på sociala kanaler.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Kommentarer och klassificeringar',
          text: 'Du kan kommentera, klassificera och sätta stjärnor till sökarna. Kom ihåg att markera ett status åt kandidaten när du gjort beslutet gällande kandidaten. Kandidaten ser inte denna information. Kom ihåg att informera kandidaten när du gjort beslutet.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Organisationens profil',
      branding: 'Branding',
      stages: 'Faser',
      emailTemplates: 'E-postmallar',
      evaluationScales: 'Utvärderingsskalor',
      competencies: 'Kompetenser',
    },

    passcode: {
      passcode: 'Lösenord',
      showPasscode: 'Visa accesskoden',
      hidePasscode: 'Göm accesskoden',
    },

    passwordIndicator: {
      errors: [
        'Lösenordet måste bestå av minst 12 tecken. ',
        'Lösenordet måste bestå av färre än 128 tecken.',
        'Lösenordet får inte innehålla sekvenser av tre eller flera upprepade tecken.',
        'Lösenordet ska innehålla minst en liten bokstav: a-z',
        'Lösenordet ska innehålla minst en stor bokstav: A-Z',
        'Lösenordet ska innehålla minst ett nummer: 0-9',
        'Lösenordet ska innehålla minst ett specialtecken: (t.ex. !, #, &)',
      ],
      strengthLabel: 'Lösenordets styrka: ',
      strengthValue: {
        insufficient: 'Otillräcklig',
        weak: 'Svag',
        medium: 'Medium',
        strong: 'Stark',
      },
      learnMore: 'Lär dig hur du skapar ett starkt lösenord',
    },

    personDetails: {
      namePlaceholder: 'Sökande',
      links: 'Länkar',
      attachments: 'Bilagor',
      coverLetter: 'Följebrev',
      referrer: 'Ursprung',
      referrerInfo: 'Den webbplats från vilken kandidaten kom till tjänsten.',
      lastSeen: time => `Senast sedd ${time}.`,
      headerAdditionalInformation: 'Tilläggsinformation',
      state: {
        invited: 'Inbjuden',
        visited: 'Besökte',
        incomplete: 'Ofullständig',
        completed: 'Färdig',
      },
      liveCandidateState: {
        scheduling: 'Val av intervjutid',
        notInvited: 'Ingen inbjudan skickad',
        invited: 'Inbjuden',
        interviewed: 'Intervjuad',
        evaluated: 'Utvärderad',
      },
      notVisited: 'Har inte besökt på intervju.',
      otherPersons: count => `Hittas också i ${count} andra positioner,`,
      name: 'Namn',
      email: 'E-postadress',
      phone: 'Telefonnummer',
      city: 'Stad',
      deadline: date => `Tidsfrist: ${date}`,
      deadlineExpired: 'Tidsfristen har passerat',
    },

    personEdit: {
      header: 'Redigera kandidatens uppgifte',
      description: context => `Du kan redigera all basinformation som syns till kandidaterna på ${context === 'application' ? 'ansökningsformuläret' : 'intervjuformuläret'}.`,
      name: 'Kandidatens namn',
      email: 'Kandidatens epost',
      phone: 'Kandidatens telefonnummer',
      city: 'Kandidatens nuvarande hemstad',
      link: 'Ange länk',
      links: 'Lägg till länkar',
      coverLetter: 'Följebrev',
      attachments: 'Bilagor',
      save: 'Spara',
      cancel: 'Avbryt',
      editDetails: 'Redigera uppgifter',
      editSuccess: 'Kandidatens uppgifter är nu sparade!',
    },

    personRow: {
      noStage: 'Ännu inte flyttad till fasen',
      lastSeen: time => `Senast sedd ${time}.`,
      notVisited: 'Har inte besökt på intervju.',
      selectPerson: 'Välja',
      deselectPerson: 'Avmarkera',
      openPersonPage: 'Öppna',
      interviewStartTime: 'Intervju starttid',
      noStartTimeSelected: 'Ingen starttid vald',
      icons: {
        messages: messagesSent => `${messagesSent} meddelanden skickade`,
        message: messagesSent => `${messagesSent} meddelande skickat`,
        noMessages: 'Inga meddelanden skickade',
        introduction: introductions => `${introductions} introduktion`,
        introductions: introductions => `${introductions} introduktioner`,
        noIntroductions: 'Inga introduktioner',
        comment: comments => `${comments} kommentar`,
        comments: comments => `${comments} kommentarer`,
        noComments: 'Inga kommentarer',
        appliedWithLinkedIn: 'Sökt med LinkedIn profilen',
      },
      state: {
        invited: 'Inbjuden',
        visited: 'Besökte',
        incomplete: 'Ofullständig',
        completed: 'Färdig',
        scheduling: 'Val av intervjutid',
        notInvited: 'Ingen inbjudan skickad',
        interviewed: 'Intervjuad',
        evaluated: 'Utvärderad',
      },
      deadline: date => `Tidsfrist: ${date}`,
      deadlineExpired: 'Tidsfristen har passerat',
    },

    pipeline: {
      editInterview: 'Redigera uppgifterna',
      titleLabel: 'Titel',
      endTimeLabel: 'Öppen fram tills',
      statusLabel: 'Status',
      locationLabel: 'Plats',
      editStages: 'Redigera faser',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: 'Hantera sökandena genom olika stadium. Flytta sökande från ett stadium till ett annat när rekryteringen fortskrider. Du kan också filtrera sökandena enligt stadier och andra filter.',
    },

    positionListing: {
      type: 'Typ',
      title: 'Titel',
      owner: 'Ägare',
      count: 'Antal',
      invited: 'Inbjuden',
      visited: 'Besökt',
      answered: 'Besvarad',
      hired: 'Anställd',
      leadTime: 'Ledtid',
      leadTimeValue: v => `${v} dagar`,
      created: 'Skapad datum (GMT)',
      start: 'Publiceringsdatum (GMT)',
      end: 'Öppen fram till (GMT)',
      jobAdLabel: 'Arbetsannons',
      interviewLabel: 'Video intervju',
      timedLabel: 'Tidsinställd intervju',
      embedLabel: 'Inbakad intervju',
      publicLabel: 'Offentlig intervju',
      timezone: 'Timezone',
      feedback: 'Feedbackstatistik',
    },

    qrCodeDownload: {
      download: 'Ladda ner QR-koden',
    },

    recentPositionsContainer: {
      createNew: 'Skapa ny',
      showAll: 'Visa alla',
    },

    recentJobAds: {
      openJobPositions: 'Jobb',
      showAllJobPositions: 'Visa alla jobb',
      createNewJobPosition: 'Skapa nytt jobb',
      subscriptionNeeded: 'Du behäver en aktiv prenumeration för att skapa en ny position.',
      confirmSingleHire: 'Ett av dina köpta enkelrekryteringar används för denna position.',
      newApplications: 'Ogranskade',
      responses: 'Ansökningar',
    },

    recentInterviews: {
      openVideoInterviews: 'Videointervjuer',
      showAllVideoInterviews: 'Visa alla videointervjuer',
      createNewVideoInterview: 'Skapa ny videointervju',
      invites: 'Inbjudningar',
      responses: 'Svar',
      timedTitle: 'Tidsinställd intervju',
    },

    registrationForm: {
      title: 'Registrera dig',
      email: 'E-postadress',
      submit: 'Logga in till tjänsten',
      password: 'Lösenord',
      confirmPassword: 'Confirm lösenord',
      agreeTos: 'Jag har läst och godkänner ',
      agreeTosLinkText: 'Recrights användarvillkor.',
      privacyPolicy: 'Jag har tagit del av ',
      privacyPolicyLinkText: 'integritetspolicyn.',
      licenseAgreement: 'Jag godkänner på min organisations vägnar ',
      licenseAgreementLinkText: 'Recrights Allmänna tjänstevillkor.',
      newsletter: 'Prenumerera till det månatliga nyhetsbrevet.',
      name: 'Namn',
      namePlaceholder: 'Förnamn Efternamn',
      organization: 'Organisation',
      companyDomain: domain => `Tillåt användare att logga in med ${domain} domän som ska läggas till i det här företaget.`,
      error: {
        password: {
          isRequired: 'Lösenord krävs. ',
          isValidPassword: 'Ett giltigt lösenord måste vara minst 12 tecken och innehålla minst en stor bokstav, en liten bokstav och ett nummer.',
          passwordsMatch: 'Lösenorden matchar inte.',
        },
      },
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Kontakta den person som ansvarar för fakturering i din organisation.',
    },

    search: {
      placeholder: 'Sök',
    },

    searchFilter: {
      filter: 'Filter',
      headings: {
        location: 'Plats',
        state: 'Framsteg',
        status: 'Status',
        tags: 'Tags',
        rating: 'Poäng',
        stage: 'Fas',
      },
      state: {
        invited: 'Inbjuden',
        visited: 'Besökte',
        incomplete: 'Ofullständig',
        completed: 'Färdig',
        scheduling: 'Val av intervjutid',
        notInvited: 'Ingen inbjudan skickad',
        interviewed: 'Intervjuad',
        evaluated: 'Utvärderad',
      },
      status: {
        open: 'Öppen',
        filled: 'Ifylld',
        cancelled: 'Annullerad',
        closed: 'Stängd',
        draft: 'Utkast',
        hidden: 'Dold',
        unpublished: 'Utkast',
        hired: 'Anställd',
        proceed: 'Gå vidare',
        new: 'Ny',
        all: 'Alla',
        videointerviewed: 'Videointervju',
        personalinterview: 'Personlig intervju',
        withdrawn: 'Borttagen',
        scheduledinterview: 'Schemalagd intervju',
        rejected: 'Avvisad',
        finished: 'Upphöra',
        coming: 'På kommande',
        active: 'Pågående',
      },
    },

    selectListings: {
      title: 'Publiceringsalternativ',
      description: 'Välj var arbetsannonsen publiceras.',
    },

    session: {
      account: 'Kontohantering',
      language: 'Språk',
      logout: 'Logga ut',
      whatsNew: 'Vad är nytt på Recright?',
      trainingMaterial: 'Recright-övningar',
      expired: 'Var god, logga in igen.',
      showTutorial: 'Visa anvisning',
      helpCenter: 'Recright Onlinesupport',
      organization: 'Organisation',
    },

    showFeedbackPulse: {
      showPulse: 'Visa återkoppling',
      positive: avg => `${avg}% positiva svar`,
      feedbackStatistics: 'Feedbackstatistik',
      noFeedback: 'Ingen återkoppling ännu',
      responses: responses => `${responses} Svar`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `Du har ${count} st enkla rekryteringar kvar på ditt konto.`,
      notificationBody: 'Att bjuda in kandidater eller publicera en intervju kommer att använda en enkelrekrytering.',
    },

    singleHires: {
      currentCount: count => `${count} st enkla rekryteringar kvar.`,
      purchase: 'Köp en enkelrekrytering',
      label: 'Single hire',
      confirmMessage: amount => `Bekräfta ditt köp av enkelrekrytering. ${amount} EUR kommer att debiteras från ditt kreditkort.`,
    },

    smartrecruitersPublish: {
      title: 'Smartrecruiters Integration',
      description: 'Du kan tillägga och ta bort individuella intervjuer från Video Intervju listan i Smartrecruiters.',
      notification: 'Observera att det kan ta upp till 24 timmar innan intervjuerna visas i Smartrecruiters.',
      addButton: 'Lägg till i Smartrecruiters',
      removeButton: 'Ta bort från Smartrecruiters',
      confirmRemove: 'Är du säker på att du vill ta bort intervjun från Smartrecruiters?',
      addConflict: 'Intervjun har redan lagts till i videointervju-listan',
      removeConflict: 'Intervjun har redan tagits bort från videointervju-listan',
    },

    subscriptionExpired: {
      message: 'Din prenumeration har utgått.',
    },

    stars: {
      yourRating: rating => `Ditt betyg: ${rating}`,
      totalVotes: count => `Totalt ${count} betyg`,
      yourRatingReset: 'Ta bort ditt betyg',
    },

    statisticsFilters: {
      timeframe: 'Timeframe',
      owner: 'Owner',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Interviews',
      applicationsLabel: 'Applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Öppen',
        filled: 'Ifylld',
        cancelled: 'Annullerad',
        closed: 'Stängd',
        draft: 'Utkast',
        hidden: 'Dold',
        unpublished: 'Utkast',
      },
      person: {
        hired: 'Anställd',
        proceed: 'Gå vidare',
        new: 'Ny',
        videointerviewed: 'Videointervju',
        personalinterview: 'Personlig intervju',
        withdrawn: 'Borttagen',
        scheduledinterview: 'Schemalagd intervju',
        rejected: 'Avvisad',
      },
    },

    trialBanner: {
      notification: days => `Din testperiod håller ännu på i ${days} dagar. Om du vill fortsätta användningen efter testperiodens slut måste du köpa en licens eller en enskild rekrytering.`,
      trialEnded: 'Din testperiod har nu slutat. Om du önskar fortsätta användningen av tjänsten måste du köpa en licens eller en enskild rekrytering.',
      orderHere: 'Beställ här!',
    },

    favorite: {
      popupHeader: 'Välj videobibliotek',
      yourVideos: 'Dina videon',
      companyVideos: 'Organisationens videon',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Lägg till videon i dina favoriter genom att klicka på hjärtat i övre vänstrahörnet av videon. Du kan ta bort videoklippet från dina favoriter via <a href="${videoLibrary}">Videobiblioteket</a>.`,
    },

    brandingPreview: {
      preview: 'Förhandsvisning',
      header: 'Exempel rubrik',
      body: lorem => `Det här är ett exempel på typsnittet. ${lorem}`,
      linkText: 'Detta är ett exempel på en länk.',
      primaryButtonText: 'Primär knapp',
      secondaryButtonText: 'Sekundär knapp',
      backButtonText: 'Tillbaka-knapp',
    },

    usersList: {
      generalInformation: 'Allmän information',
      latestVisit: date => `Senaste besöket ${date}`,
      neverLogger: 'Aldrig loggat in',
      externalUser: 'Extern användare',
      inviteExpired: 'Förfallen inbjudan',
      permissions: {
        permissions: 'Rättigheter',
        seeAllPositions: 'Se alla annonser',
        createJobPositions: 'Lägg till ny annons',
        createInterviews: 'Skapa intervju',
        account: 'Ändra företagsinformation',
        billing: 'Fakturering',
        reporting: 'Rapportering',
        editUsers: 'Redigera användare',
        default: 'Standard rättigheter',
      },
      actions: {
        actions: 'Åtgärder',
        activate: 'Aktivera',
        deactivate: 'Deaktivera',
        removeFromOrganisation: 'Ta bort från organisation',
        hiddenPositions: 'Dolda annonser',
      },
      noUsers: 'Inga användare. Om du filtrerade listan, försök minska antalet filter.',
    },

    usersListFilters: {
      sort: {
        name: 'Namn',
        email: 'E-post',
        lastAdminAccess: 'Senaste admin inloggning',
      },
      find: 'Sök',
      clearSelections: 'Töm dina val',
      usersCount: count => `Totalt ${count} användare`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Redigera flera användares rättigheter',
      deactivateSelectedUsers: 'Deaktivera utvalda användare',
      activateSelectedUsers: 'Aktivera utvalda användare',
      addNewUsers: 'Bjud in användare',
      save: 'Spara',
      cancel: 'Annulera',
      editUsersPermissions: 'Redigera användares rättigheter',
    },

    linkedInInformation: {
      title: 'LinkedIn information:',
      since: 'Sedan',
      summary: 'Sammanfattning:',
      fullLinkedInProfile: 'LinkedIn profilen i sin helhet',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-postet studsades tillbaka. Kontrollera att mottagaren har fått ditt meddelande.',
      },
      Permanent: {
        General: 'Skickandet av e-postet misslyckades. Mottagarens e-postleverantör avvisade meddelandet.',
        NoEmail: 'E-postadress existerar inte.',
        Suppressed: 'E-postet skickades inte på grund av tidigare misslyckade försök.',
      },
      Transient: {
        General: 'E-postet studsades tillbaka. Kontrollera att mottagaren har fått ditt meddelande.',
        MailboxFull: 'Mottagarens inkorg är full.',
        MessageTooLarge: 'Innehållet av meddelandet är för stort.',
        ContentRejected: 'Innehållet av meddelandet avvisades.',
        AttachmentRejected: 'Bifogade bilagan avvisades.',
      },
    },

    videoBackgroundUpload: {
      header: 'Organisationens bakgrundsbild för video',
      description:
        'Bild som användare i din organisation kan använda som bakgrundsbild för de videor de spelar in.',
      add: 'Lägg till bakgrundsbild för video',
      info: 'Rekommenderad bildstorlek är 720x480 pixlar.',
    },
  },

  page: {
    account: {
      title: 'Kontohantering',
      details: 'Kontouppgifter',
      name: 'Kontonamn',
      save: 'Spara',
      saved: 'Kontouppgifterna är sparade.',
      signature: 'Underskrifts',
      permissions: 'Rättigheter',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Lösenord',
      statistics: 'Statistics',
      organization: 'Organisation',
    },

    actionBar: {
      selection: 'valda',
    },

    organisationProfile: {
      title: 'Organisationens profil',
      details: 'Inställningar för organisationens profil',
      brandingHeader: 'Organisationens branding',
      name: 'Organisationens namn',
      owner: 'Kontoägare',
      customReplyToSubtitle:
        'Här kan du redigera namnet och svarsadressen för avsändaren av inbjudan. Om fältet lämnas tomt används namnet och adressen för den användare som skickar inbjudan.',
      customReplyToEmail: 'E-postadress för svar på inbjudan till intervju',
      customReplyToName:
        'Namnet som kommer att visas som avsändare på inbjudan till intervju',
      senderInfoDisabled:
        'Avsändarens uppgifter kan inte redigeras då videointervjuer är inaktiverade för din organisation.',
      slug: 'Karriärsidans URL',
      slugUnavailable: 'Denna URL är redan reserverade',
      slogan: 'Karriärsidans slogan',
      language: 'Karriärsidans språk',
      languagePlaceholder: 'Välj',
      rss: 'Karriärer RSS-flöde',
      type: 'Kontotyp',
      types: {
        free: {
          title: 'Fri',
          description: 'Fördelar med fritt\n1 för användare\n1 öppet jobb vid tidpunkten',
        },
        basic: {
          title: 'Elementär',
          description: 'Fördelar med fria\nObegränsade öppna\nVideointervjuer',
        },
        team: {
          title: 'Team',
          description: 'Fördelar med Team\nObegränsade jobb\nVideointervjuer\nPresentationer av kandidater',
        },
      },
      save: 'Spara',
      reset: 'Reset',
      companyAdminUsers: 'Company admin users',
      saved: 'Organisationens information sparat.',
      cancel: 'Avbryt',
      confirmLeave: 'Du har osparade ändringar. Är du säker på att du vill lämna sidan?',
      error: {
        required: '* Fälten markerade med en asterisk är obligatoriska.',
      },
      emailBrandingHeader: 'Varumärkesinställningar för e-post',
      emailBrandingDescription:
        'Anpassa färgerna på e-postmeddelanden som skickas till kandidaterna.',
    },

    organisationCompetencies: {
      title: 'Organisation\'ens kompetenser',
      description: 'Du kan redigera, lägga till och radera organisationens kompetenser här. Dessa kommer att vara standardkompetenser i nya platser som skapas för detta företag och de kan hittas hos kandidater på platserna i avsnittet "Kompetens och egenskaper".',
    },

    organisationStages: {
      title: 'Organisationens rekryteringsfaser',
      description: 'Du kan redigera, ordna och radera organisationens rekryteringsfaser. Dessa rekryteringsfaser blir standard till nya positioner skapade under denna organisation.',
    },

    organisationEvaluationScales: {
      language: 'Språk',
      name: 'Namn',
      description: 'Beskrivning',
      resetToDefaults: 'Återställ ursprungliga',
      confirmLanguageChange:
        'Är du säker på att du vill byta språk? Alla ändringar som inte har sparats kommer att gå förlorade.',
    },

    organisationEmailTemplates: {
      preview:
        'Förhandsgranska e-postmeddelandet (förhandsgranskningen innehåller inte all formatering i det slutliga e-postmeddelandet)',
      preview2:
        'E-postmallens färger kan anpassas i organisationens varumärkesinställningar.',
      timedInterviewPreviewInfo:
        'Meddelandet om den tidsinställda intervjun innehåller inte informationen om att kontakta supporten.',
      templateTypes: {
        interviewInvite: 'Inbjudan till videointervju',
        timedInterviewInvite: 'Inbjudan till tidsinställd videointervju',
        interviewCompleted:
          'Meddelande om avslutad intervju / tackmeddelande som skickas till kandidaterna',
        applicationCompleted:
          'Jobbansökan slutförd / tackmeddelande till jobbsökande',
      },
      subHeaders: {
        jobAdLabel: 'Arbetsannons',
        interviewLabel: 'Video intervju',
      },
      deleteTemplate: 'Ta bort mall',
      confirmation: templateName =>
        `Är du säker på att du vill ta bort mallen "${templateName}" från organisationens e-postmallar?`,
      deleteSuccess:
        'Mallen har tagits bort från organisationens e-postmallar.',
      emailTemplateInfo: 'För tillfället kan du bara spara en mall med ett språk.',
      templateError: 'Det finns redan en mall med samma namn eller språk.',
    },

    application: {
      back: 'Tillbaka till ansökningslistan',
      delete: 'Radera ansökan',
      deleted: 'Ansökan är raderad',
      interviewClosed: 'Intervjun är stängd',
      resendInvitation: 'Återsänd inbjudan till den sökande',
      changeStage: 'Överför kandidaten till andra fasen',
      commentsAndClassifications: 'Kommentarer och klassifikationer',
      openingTitle: title => `Videointervju - ${title}`,
      yourRatingText: 'Ditt betyg:',
      competencesAndCompatibility: 'Kompetens och egenskaper',
      duplicateCompetency: 'Kompetensen existerar redan',
      competencyNotFound: 'Kompetensen har raderats eller finns inte',
      confirmDelete: 'Är du säker att du vill radera ansökan?',
      lastSeen: time => `Senast sedd ${time}.`,
      stageChangedInfo: stage => `Nu när du har flyttat kandidaterna till rekryteringsfasen "${stage}", låt dem veta! Skicka dem ett mail eller ett videoklipp.`,
      stageChanged: 'Fantastiskt!',
      close: 'Stäng',
      reopenProcessConfirm: 'Är du säker på att du vill flytta den här kandidaten från "Borttagen" och återföra hen till rekryteringsprocessen? Efter att kandidaten har bekräftat kan hen återigen svara på alla intervjuer som hen inte ännu har slutfört.',
      withdrawConfirm: 'Är du säker på att du vill ta bort den här kandidaten från rekryteringsprocessen? När kandidaten är borttagen kan hen inte längre svara på några intervjuer som hen blir inbjuden till.',
      changestageTooltip: 'Här kan du se och välja kandidatens stadium. Klicka på kandidatens önskade stadie för att ändra den.',
      commentsTooltip: 'Du kan kategorisera och kommentera kandidaten för dina kollegor. Kandidaterna ser inte denna information.',
      competencesTooltip: 'Du kan se kandidatens kompatibilitet. Skapa en kompetens och rösta. Kandidaterna ser inte denna information.',
      actionlogTooltip: 'Kommentarer, stadieändringar, meddelanden och andra aktiviteter visas här. Kandidaten kan inte se denna information.',
      stage: {
        new: 'Ny',
        hired: 'Anställd',
        proceed: 'Gå vidare',
        personalinterview: 'Personlig intervju',
        withdrawn: 'Borttagen',
        scheduledinterview: 'Schemalagd intervju',
        rejected: 'Avvisad',
        videointerviewed: 'Videointervju',
      },
      state: {
        invited: 'Inbjuden',
        visited: 'Besökte',
        incomplete: 'Ofullständig',
        completed: 'Färdig',
      },
      notVisited: 'Har inte besökt på intervju.',
      deadline: date => `Tidsfrist: ${date}`,
      deadlineExpired: 'Tidsfristen har passerat',
    },

    billing: {
      title: 'Fakturering',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `Nästa faktura kommer att vara ${nextBillingPeriodAmount} EUR den ${nextBillingDate}`,
      status: 'Status',
      singleHire: 'Single hire',
      billingOverview: 'Faktureringsöversikt',
      payment: 'Betalning',
      paymentHistory: 'Betalningshistorik',
      updateDetails: 'Uppdatera betalningsuppgifterna',
      billingStatus: {
        pending: 'Väntar på bearbetning',
        active: 'Aktiv',
        pastdue: 'Förfallit',
        expired: 'Föråldrad',
        canceled: 'Annullerad',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Åtgärdsloggen',
      back: 'Tillbaka till kandidatlistan',
      delete: 'Radera kandidaten',
      deleted: 'Kandidaten är raderad',
      interviewClosed: 'Intervjun är stängd. Inga återinbjudningar skickades.',
      resendInvitation: 'Återsänd inbjudan till kandidaten',
      changeStage: 'Överför kandidaten till andra fasen',
      introducedTo: 'De gjorda presentationerna:',
      yourRatingText: 'Ditt betyg:',
      competencesAndCompatibility: 'Kompetens och egenskaper',
      duplicateCompetency: 'Kompetensen existerar redan',
      competencyNotFound: 'Kompetensen har raderats eller finns inte',
      confirmDelete: 'Är du säker att du vill radera kandidaten?',
      stageChangedInfo: stage => `Nu när du har flyttat kandidaterna till rekryteringsfasen "${stage}", låt dem veta! Skicka dem ett mail eller ett videoklipp.`,
      stageChanged: 'Fantastiskt!',
      close: 'Stäng',
      hideStages: 'Göm faserna',
      showStages: 'Visa faserna',
      resetQuestionResponseSuccess: 'Kandidatens svar har tagits bort',
      stage: {
        new: 'Ny',
        hired: 'Anställd',
        proceed: 'Gå vidare',
        personalinterview: 'Personlig intervju',
        withdrawn: 'Borttagen',
        scheduledinterview: 'Schemalagd intervju',
        rejected: 'Avvisad',
        videointerviewed: 'Videointervju',
      },
      summaryOfAllAnswers: 'Sammandrag av alla svar',
      summaryOfAllAnswersInsights: 'Sammandrag av alla insikter',
    },

    dashboard: {
      upcomingLiveInterviews: 'Liveintervjuer',
      showAllLiveInterviews: 'Show all live interviews',
      createNewLiveInterview: 'Create new live interview',
      interviewRounds: 'Interview rounds',
      interviewGuides: 'Intervjuguide-mallar',
      welcome: name => `Välkommen, ${name}!`,
      createNewGuide: 'Skapa ny intervjuguide-mall',
      liveCard: {
        startTime: 'Start tid',
        interviewers: 'Intervjuare',
        candidates: 'Kandidater',
      },
      interviewRoundCard: {
        interviews: 'Interviews',
        admins: 'Admins',
        endTime: 'Open until',
      },
      oldLivesLinkText: 'Gamla liveintervjuer',
    },

    interviewEdit: {
      title: 'Intervjutitel',
      titleLabel: 'Intervjutitel',
      location: 'Plats',
      publishTimePlaceholder: 'Publiceringsdatum',
      publishTimeTooltip: 'Bestäm ett publiceringsdatum för intervjun. Du kan ändra datumet närhelst du vill.',
      endTime: 'Öppen fram tills',
      endTimeTooltip: 'Lägg till ett datum när svarstiden slutar automatiskt.',
      candidateAnswerTimeDays: 'Dagar för att skicka in svar',
      candidateAnswerTimeDaysTooltip: 'Ange hur många dagar varje kandidat har på sig att slutföra intervjun efter inbjudan. Om ett publiceringsdatum är angett räknas tidsfristen från publiceringsdatumet. Om intervjuns sluttid infaller före den beräknade tidsfristen används sluttiden istället.',
      candidateAnswerTimeDaysTooltipWithoutPublishTime: 'Ange hur många dagar varje kandidat har på sig att slutföra intervjun efter inbjudan. Om intervjuns sluttid infaller före den beräknade tidsfristen används sluttiden istället.',
      candidateAnswerTimeDaysPlaceholder: 'Dagar för att skicka in svar är inte angivet',
      candidateAnswerTimeDaysInvalid: 'Värdet måste vara minst 1',
      unsetCandidateAnswerTimeDays: 'Ta bort',
      saveCandidateAnswerTimeDays: 'Spara',
      timezone: 'Tidszon',
      isNotPastDate: 'datumet är i det förflutna.',
      interviewIsClosed: 'Intervjun är för tillfället stängd. Vill du ',
      interviewIsClosedLink: 'öppna den',
      edit: {
        details: 'Redigera uppgifterna',
        status: 'Ändra status',
        team: 'Redigera teamet',
      },
      questions: 'Intervjufrågor',
      answerable: 'Frågan kan besvaras',
      required: 'Svar krävs',
      questionsDescription: 'Dessa frågor ska deltagarna besvara.',
      questionsNotEditable: 'Frågor kan inte redigeras efter inbjudan har skickats.',
      saved: 'Intervjun är sparad',
      deleted: 'Intervjun är raderad',
      delete: 'Radera intervjun',
      cancel: 'Avbryt',
      save: 'Spara',
      language: 'Intervjuspråk',
      languagePlaceholder: 'Välj',
      languages: {
        en: 'Engelska',
        fi: 'Finska',
      },
      confirmLeave: 'Du har osparade ändringar. Är du säker på att du vill lämna sidan?',
      OnboardingHeadImageSize: 'Rekommenderad storlek på bakgrundsbilden är 1440px*320px eller större.',
      takeLimitLabel: 'Antal försök',
      answerTimeLabel: 'Svarstid',
      preparationTimeLabel: 'Förberedelsetid',
      confirmHeader: 'Är du säker på att du vill ta bort den här intervjun?',
      integratedConfirmContent: 'Denna intervju är integrerad i ett annat system och att ta bort den kan orsaka problem med integrationen.',
      evaluationCriteriaLabel: 'Utvärderingskriterier',
    },

    interview: {
      endTime: date => (date ? `fram tills ${date}` : ''),
      edit: 'Redigera intervjuuppgifterna',
      copy: 'Kopiera intervju',
      editInvitation: 'Redigera inbjudningsmeddelandet',
      editTeam: 'Redigera teamet',
      editMenu: 'Redigera',
      questions: 'Intervjufrågor',
      changeStatus: 'Ändra status',
      publishSettings: 'Publicerings inställningar',
      invite: 'Bjud in kandidater',
      showCandidates: 'Visa kandidater',
      oneError: ' En inbäddad intervju kan endast ha en fråga.',
      copySuccess: 'Intervjun har kopierats framgångsrikt',
      editIntroduceBatches: 'Redigera introduktionen',
      editEmailSettings: 'Redigera e-postinställningarna',
    },

    interviews: {
      allInterviews: 'Alla videointervjuer',
      createNewVideoInterview: 'Skapa ny videointervju',
      filter: 'Skapa intervjuer',
      invites: 'Inbjudningar',
      responses: 'Svar',
      sort: {
        title: 'Titel',
        publishTime: 'Publiceringsdatum',
        endTime: 'Slutdatum',
        createdAt: 'Skapad datum',
        updatedAt: 'Senast redigerad',
        answeredCount: 'Kandidater',
      },
    },

    interviewCandidates: {
      preview: 'Förhandsvisning',
      endTime: date => (date ? `Öppen fram tills ${date}` : ''),
      publicTitle: 'Offentlig intervju',
      embedTitle: 'Inbakad intervju',
      placeholder: {
        first: 'Inga kandidater ännu.',
        second: 'Du kan också göra din videointervju offentlig.',
        third: 'Då kan alla intresserade i positionen se den offentliga intervjun och ansöka om det.',
        fourth: 'Och glöm inte att alla dessa inte är längre bort än bara en knapp i titelbalken ovan.',
      },
      title: 'Alla kandidater',
      sort: {
        default: 'Standard',
        updatedAt: 'Senast redigerad',
        name: 'Namn',
        rating: 'Poäng',
        createdAt: 'Skapad datum',
      },
      sendMessage: 'Skicka meddelande',
      changeStage: 'Överför kandidaten till andra fasen',
      introduce: 'Presentera',
      filter: 'Sök kandidater',
      hideFilters: 'Göm filtrar',
      showFilters: 'Visa filtrar',
      emailSent: 'E-postmeddelandet skickades!',
      interviewClosedError: 'Du kan inte bjuda in en sökande på nytt till en videointervju som är stängd.',
      excel: 'Ladda ner kandidaternas information till excel',
      reInviteSent: candidates => `${candidates} återinbjudningar har skickats!`,
    },

    jobAdEdit: {
      preview: 'Förhandsgranska',
      confirm: 'Är du säker på att du vill lägga till detta jobb?',
      deleteHeader: 'Är du säker på att du vill radera jobbplatsen?',
      deleteContent: 'Ifall du raderar den här arbetsannonsen kommer även all information relaterat till arbetsannonsen, så som ansökningar och video intervjuer, att raderas.',
      titlePlaceholder: 'Jobbtitel',
      locationPlaceholder: 'Plats',
      timezone: 'Tidszon',
      endTimePlaceholder: 'Öppen fram tills',
      endTimeTooltip: 'Lägg till ett datum när ansökningstiden slutar automatiskt',
      isNotPastDate: 'datumet är i det förflutna.',
      publishTimePlaceholder: 'Publiceringsdatum',
      publishTimeTooltip: 'Lägg till ett datum när arbetsplatsen blir offentlig. Du kan ändra datumet när du vill.',
      language: 'Språk',
      languagePlaceholder: 'Välj',
      languages: {
        en: 'Engelska',
        fi: 'Finska',
      },
      description: 'Jobbeskrivning',
      saved: 'Jobbet är sparat',
      deleted: 'Jobbet är raderat',
      descriptionPlaceholder: 'Du kan beskriva jobbet här. \n\nDu kan också anrika beskrivningen med text formaterings verktyg som hittas här nedan.',
      createInviteOnly: 'Skapa videointervju för endast inbjudna',
      delete: 'Radera jobbet',
      cancel: 'Avbryt',
      save: 'Spara',
      confirmLeave: 'Du har osparade ändringar. Är du säker på att du vill lämna sidan?',
      singleHireEndError: 'Enkelrekryteringen kan inte användas i längre än 60 dagar',
      OnboardingHeadImageSize: 'Rekommenderad storlek på bakgrundsbilden är 1440px*320px eller större.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, öppen fram tills ${date}` : ''),
      title: 'Alla ansökningar',
      sort: {
        updatedAt: 'Senast redigerad',
        name: 'Namn',
        rating: 'Poäng',
        createdAt: 'Skapad datum',
      },
      add: 'Skapa ny ansökan',
      inviteToInterview: 'Bjud in till intervju',
      sendMessage: 'Skicka meddelande',
      changeStage: 'Överför kandidaten till andra fasen',
      introduce: 'Presentera',
      editIntroduceBatches: 'Redigera introduktionen',
      filter: 'Sök ansökningar',
      hideFilters: 'Göm filtrar',
      showFilters: 'Visa filtrar',
      addInterviewConfirm: jobAd => `Vill du skapa en ny videointervju och associera den med jobbet “${jobAd}“?`,
    },

    adminJobAdApplication: {
      name: 'Namn',
      email: 'E-postadress',
      phone: 'Telefonnummer',
      city: 'Stad',
      back: 'Tillbaka',
      continue: 'Fortsätt',
      submit: 'Lägg till',
      namePlaceholder: 'Kandidatens namn',
      emailPlaceholder: 'Kandidatens epost',
      cityPlaceholder: 'Kandidatens nuvarande hemstad',
      links: 'Lägg till länkar, t.ex. LinkedIn profil',
      legendLinks: 'Länkar',
      legendAttachments: 'Bilagor',
      legendAdditionalFields: 'Tilläggsinformation',
      legendBasicInfo: 'Grundläggande information',
      coverLetter: 'Följebrev',
      attachments: 'Bilagor',
      introduction: 'Skriv din presentation här',
      thankYou: 'Tack.',
      readyInfo: 'Tack. Kandidaten har nu lagts till för det lediga jobbet.',
      close: 'Stäng',
      required: '* Fälten markerade med en asterisk är obligatoriska.',
      excel: 'Ladda ansökandes information till excel',
    },

    jobAdPreview: {
      endTime: date => (date ? `, öppen fram tills ${date}` : ''),
      exit: 'Avsluta förhandsgranskningen',
      description: 'Jobbeskrivning',
      video: 'Arbetsgivarens videoklipp',
      questions: 'Videofråga',
      apply: 'Sök jobbet',
    },

    jobAd: {
      endTime: date => (date ? `, öppen fram tills ${date}` : ''),
      changeStatus: 'Ändra jobbstatus',
      edit: 'Redigera jobbuppgifterna',
      copy: 'Kopiera jobb',
      editInvitation: 'Redigera inbjudningsmeddelandet',
      editTeam: 'Redigera teamet',
      editMenu: 'Redigera',
      description: 'Jobbeskrivning',
      video: 'Arbetsgivarens videoklipp',
      questions: 'Videofråga',
      apply: 'Sök jobbet',
      showApplications: 'Visa ansökningar',
      publicLink: 'Jobbannons offentlig sida',
      copySuccess: 'Jobbet har kopierats framgångsrikt',
    },

    jobAds: {
      subscriptionNeeded: 'Du behäver en aktiv prenumeration för att skapa en ny position.',
      responses: 'Ansökningar',
      createNewJobPosition: 'Skapa nytt jobb',
      confirmSingleHire: 'Ett av dina köpta enkelrekryteringar används för denna position.',
      allJobPositions: 'Alla jobb',
      filter: 'Sök jobb',
      sort: {
        title: 'Titel',
        publishTime: 'Publiceringsdatum',
        applicationCount: 'Ansökningar',
        endTime: 'Slutdatum',
        createdAt: 'Skapad datum',
        updatedAt: 'Senast redigerad',
      },
    },

    jobAdSaved: {
      title: 'Jobbet är sparat!',
      description: 'Din jobbannons är nu sparad. Här är en offentlig länk till jobbannonsen:',
      addApplication: 'Direkt länk till ansökningsformuläret:',
      toDashboard: 'Framsidan',
      toJobAd: 'Tillbaka till jobbannonsen',
    },

    interviewGuides: {
      allGuides: 'Alla intervjuguide-mallar',
      createNewGuide: 'Skapa ny intervjuguide-mall',
      noResults: 'Inga intervjuguide-mallar hittades.',
      sort: {
        title: 'Titel',
        createdAt: 'Skapad datum',
      },
    },

    interviewGuide: {
      headerTitle: 'Intervjuguide',
      titleLabel: 'Titel på intervjuguiden',
      editTitle: 'Redigera intervjuguide',
      titlePlaceholder: 'Ange en titel för intervjuguiden',
      languageLabel: 'Intervjuguidens språk',
      descriptionLabel: 'Beskrivning',
      descriptionPlaceholder: 'Beskriv syftet med denna intervjuguide.',
      noDescription: 'Ingen beskrivning angiven.',
      saved: 'Intervjuguide sparad',
      stepsLabel: 'Intervjuguidens delar',
      stepsSubtitle: 'Definiera intervjuns delar.',
      deleted: 'Intervjuguide borttagen',
      delete: 'Ta bort intervjuguiden',
      cancel: 'Avbryt',
      save: 'Spara intervjuguiden',
      ownerLabel: 'Ägare',
      evaluationScale: 'Utvärderingsskala',
      confirmLeave:
        'Du har osparade ändringar. Är du säker på att du vill lämna denna sida?',
      confirmHeader: 'Är du säker på att du vill ta bort denna intervjuguide?',
    },

    interviewRounds: {
      allRounds: 'Alla intervjurundor',
      createNewRound: 'Skapa ny intervjurunda',
      noResults: 'Inga intervjurundor hittades.',
      total: (count) => `${count} intervjurundor`,
      sort: {
        title: 'Titel',
        createdAt: 'Skapad datum',
        updatedAt: 'Senast redigerad',
        endTime: 'Öppen fram tills',
        owner: 'Ägare',
      },
    },

    interviewRound: {
      languageAndGuideInfoTextTitle:
        'Intervjuerna i denna runda kommer att använda den intervjuguide och det språk som du väljer här.',
      languageAndGuideInfoText:
        'Språk och guide kan för närvarande inte redigeras per intervju. Intervjurundans guide och språk kan inte ändras efter att du har bjudit in kandidater till denna runda.',
      selectedCandidatesInfoText:
        'Vissa av de valda kandidaterna har redan blivit inbjudna. Om du vill boka om, öppna kandidatsidan.',
      closedWarningText:
        'Intervjurundans status är för närvarande "stängd". Vill du ',
      closedLinkText: 'ändra den till "öppen"?',
      addCandidatesTitle: 'Lägg till kandidater',
      candidatesAdded: (count) =>
        `${count} kandidater tillagda i intervjurundan.`,
      existingCandidates: (count) =>
        `${count} kandidater var allerede i interviewrundan.`,
      scheduleInterview: 'Schemalägg intervju',
      headerTitle: 'Intervjurunda',
      titleLabel: 'Titel för intervjuorunda',
      languageLabel: 'Språk för intervjurunda',
      endTimeLabel: 'Öppen till',
      timezoneLabel: 'Tidszon',
      editTitle: 'Redigera intervjurunda',
      titlePlaceholder: 'Ange titel för intervjurunda',
      interviewGuideLabel: (details) =>
        details ? 'Intervjuguide' : 'Välj intervjuguide-mall för intervjun',
      noGuide: 'Ingen intervjuguide-mall vald',
      noGuidesForLanguage: 'Inga intervjuguider tillgängliga för det valda språket',
      saved: 'Intervjurunda sparad',
      deleted: 'Intervjurunda borttagen',
      delete: 'Ta bort intervjurunda',
      candidatesInvited: 'Kandidater inbjudna.',
      cancel: 'Avbryt',
      save: 'Spara intervjurunda',
      ownerLabel: 'Ägare',
      confirmLeave:
        'Du har osparade ändringar. Är du säker på att du vill lämna denna sida?',
      confirmHeader: 'Är du säker på att du vill ta bort denna intervjurunda?',
      removeGuide: 'Rensa guide',
      noCandidates: 'Inga intervjuer ännu.',
      changeStatus: 'Ändra status för intervjurundan',
      sort: {
        updatedAt: 'Senast redigerad',
        startTime: 'Intervjus starttid',
        name: 'Namn',
        lastAccess: 'Senast tillgång',
        createdAt: 'Skapad datum',
      },
    },

    interviewInsights: {
      header: 'Intervjuinsikter',
      statisticalAnalysis: 'Statistisk analys',
      overallFeedback: 'Övergripande feedback',
      detailedFeedback: 'Detaljerad feedback',
      compliance: 'Efterlevnad',
      complianceIssue: 'Efterlevnadsproblem',
      speakingTime: 'Talartid',
      interviewer: 'Intervjuare',
      close: 'Stäng',
      candidate: 'Kandidat',
      interviewersMultiple: 'Intervjuare',
      adherence: {
        timeTable: 'Planenlighet av tidsplan',
        sections: 'Planenlighet av tidsplan per del',
        questions: 'Planenlighet av frågor',
        talkRatio: 'Fördelning av taltid',
      },
      readMore: 'Läs mer',
      analysis: 'Analys',
      sections: 'Delar',
      details: 'Detaljerad feedback',
      proposedNextSteps: 'Föreslagna nästa steg',
      analysisInProgress: 'Analys av insikter pågår...',
      analysisFailed: 'Fel vid laddning av analys av insikter.',
      tryAgainLater: 'Vänligen försök igen senare.',
      legalContext: 'Juridiskt sammanhang',
    },

    live: {
      interviewersInfo:
        'När du lägger till intervjuare som inte är administratörer för intervjurundan kommer de att läggas till som administratörer för intervjurundan.',
      noStartTimeSelected: 'Ingen starttid vald',
      noInterviewers: 'Ingen intervjuare',
      title: 'Live-intervju',
      editTitle: 'Redigera live-intervju',
      startTimeTitle: 'intervjuns starttid',
      startTime: 'Starttid',
      notScheduled: 'Ikke planlagt',
      interviewers: 'Intervjuare',
      candidate: 'Kandidat',
      candidates: 'Kandidater',
      candidateDisplayName: 'Kandidatens namn',
      messageLabel: 'Inbjudningsmeddelande',
      languageLabel: 'Språk',
      create: 'Skapa ny live-intervju',
      save: 'Spara',
      cancel: 'Avbryt',
      reschedule: 'Omboka intervju',
      schedule: 'Boka intervju',
      removeLive: 'Ta bort live-intervju',
      cancelLive: 'Avbryt live-intervju',
      evaluationLabel: 'Utvärdering',
      evaluationComparisonLabel: 'Jämföring av utvärderingarna',
      comment: 'Lägg till en ny kommentar',
      commentLabel: 'Kommentar',
      interviewInsights: 'Intervjuinsikter',
      continueEvaluation: 'Fortsätt utvärdering',
      viewRecordings: 'Visa inspelningar',
      transcriptButtonText: 'Intervjutranskript',
      interviewGuideLabel: details => details ? 'Intervjuguide' : 'Välj intervjuguide för intervjun',
      noGuide: 'Ingen intervjuguide vald',
      interviewGuideInfo:
        'Du kan bara använda en intervjuguide när det finns en kandidat placerad i intervjun.',
      enter: 'Närvara vid live-intervju',
      edit: 'Redigera intervju',
      draft: 'Ny live-intervju',
      pending: 'Väntar på kandidatens bekräftelse',
      scheduledLiveCandidateSubtitle:
        'För en schemalagd liveintervju kan du endast lägga till en kandidat.',
      confirmHeader: 'Är du säker på att du vill ta bort den här intervjun?',
      inviteFailure: (success, failed) =>
        `${success} inbjudningar skickas och ${failed} misslyckades!`,
      inviteSuccess: success => `${success} inbjudningar skickas.`,
      recordingsHeaderWithTitle: title =>
        `Inspelningar för live-intervju ${title}`,
      recordingsHeader: 'Live-intervju inspelningar',
      success: {
        create: 'Ny live-intervju har skapats',
        delete: 'Live- intervju borttagen',
        update: 'Live-intervju uppdaterad',
      },
      placeholders: {
        candidateEmails: 'Lägg till kandidat',
        interviewerEmails: 'Lägg till intervjuare',
        emailTitle: 'Titel',
        emailMessage: 'Meddelande',
        emailName: 'Namn',
      },
      successInviteSent: 'Meddelande om val av intervjutid skickat till kandidaten.',
      errorInviteNotSent: 'Meddelande kunde inte skickas.',
      startTimeChanged: 'Intervjuens starttid har ändrats.',
      rescheduleConfirmBody: 'sÄr du säker på att du vill boka om denna intervju?',
      backToRound: 'Tillbaka till Intervjurunda',
      schedulingInfo:
        'Du kan använda intervjuorganisationens användares kalendrar som är kopplade till Recright och är intervjuare i den här intervjun.',
    },

    lives: {
      allLives: 'Alla live-intervjuer',
      createNewLive: 'Skapa ny live-intervju',
      filter: 'Sök efter kandidat',
      candidates: 'Kandidater',
      sort: {
        title: 'Titel',
        startTime: 'Starttid',
        createdAt: 'Skapad datum',
      },
    },

    login: {
      title: 'Logga in till tjänsten',
      register: 'Registrera dig',
      forgot: 'Glömt lösenordet?',
      normal: 'Normal log in',
      ssoLogin: 'SSO-inloggning',
    },

    quickInterview: {
      title: 'Snabb videointervju',
      description: 'För att lära känna dig bättre så önskar vi att du kort svarar på vår snabba intervjufråga. Visa din personlighet och ge din ansökan en själ.',
      requiredNote: 'Observera att detta är den del av ansökningsprocessen, och rekryteraren får din ansökan endast efter att du har spelat in ditt svar.',
      reminderNote: 'Du kan spela in svaret genasteller så kan du fortsätta senare genom att motta en påminnelse i din e-post.',
    },

    register: {
      title: 'Designad för rekryterare!',
      leadText: 'Recright är en lättanvänd video rekryteringsplattform för rekryterare och anställande chefer. Du kan publicera öppna positioner, ta emot ansökningar och genomföra videointervjuer - allt på ett ställe! Vårt verktyg har hjälpt över 400 företag att hitta rätt personer, och ditt företag kan vara nästa! Registrera dig nedan och börja rekrytera!',
      email: 'E-postadress',
      submit: 'Registrera',
      alreadyMember: 'Redan medlem?',
      onlyForRecruiters: 'Denna registrering är endast för rekryterare och anställande chefer.',
      login: 'Logga in här.',
      registerSuccess: 'Vi har skickat dig en invitation per e-post.',
      domainError: 'Ange din arbetsrelaterade e-postadress för att registrera dig.',
      companyExistsMessage: 'Kolla din e-post för anvisningar!',
    },

    welcome: {
      title: 'Registrera dig som användare',
    },

    welcomeMulticompany: {
      welcome: companyName => `Välkommen till ${companyName}`,
      successMessage: companyName =>
        `Du har nu lagts till i organisationen ${companyName}!`,
      navigationInfo:
        'Du kan ändra din nuvarande organisation från navigeringsfältet längst upp till höger.',
      login: 'Logga in här',
    },

    forgotPassword: {
      title: 'Skapa nytt lösenord',
      email: 'E-postadress',
      submit: 'Skicka',
      sendEmail: 'Skicka oss den e-postadressen som du använder på Recright-tjänsten.',
      instructions: 'Till den adressen skickar vi instruktioner för att skapa ett nytt lösenord.',
      success: 'Om användaren hittades med den angivna e-postadressen har instruktionerna för att ändra ditt lösenord skickats till den adressen.',
    },

    changePassword: {
      title: 'Skapa ett nytt lösenord',
      name: 'Namn',
      email: 'E-postadress',
      password: 'Nytt lösenord',
      confirmPassword: 'Återge det nya lösenordet',
      submit: 'Byt lösenord',
      error: {
        password: {
          isRequired: 'Lösenord krävs. ',
          isValidPassword: 'Ett giltigt lösenord måste vara minst 12 tecken och innehålla minst en stor bokstav, en liten bokstav och ett nummer.',
          passwordsMatch: 'Lösenorden matchar inte.',
        },
      },
    },

    ssoLogin: {
      title: 'SSO-inloggning',
      description: 'Logga in med din organisations identifiering.',
      info: 'Extern autentisering är inte konfigurerad. Vänligen, använd den',
      normalLoginLinkText: 'vanliga inloggningsidentifieringen.',
      submit: 'Logga in till tjänsten',
    },

    searchResults: {
      title: 'Sökresultat',
      applications: 'Ansökningar',
      candidates: 'Kandidater',
      noApplications: 'Inga ansökningar matchar sökkriteriet',
      noCandidates: 'Inga kandidater matchar sökkriteriet',
      // TODO: Translations missing!
      query: query => (query ? `Search query: ${query}` : ''),
      noStage: 'Ännu inte flyttad till fasen',
      search: 'Sök',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText: 'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText: 'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Titel',
        owner: 'Owner',
        createdAt: 'Skapad datum',
      },
      exportLimit:
        'För många resultat. Vänligen minska tidsramen för att möjliggöra excel-export.',
      tooManyResults:
        'För många resultat. Vänligen minska tidsramen för att få resultat.',
    },

    subscribe: {
      title: 'Prenumerera',
      submit: 'Prenumerera',
      creditCard: 'Kreditkort',
      cvv: 'CVV',
      expirationDate: 'Utgångsdatum',
      vatAdvice: 'Genom att ge VAT-numret lägger vi inte till mervärdesskatten på prenumerationen.',
      vatId: 'VAT / Tax ID',
      vatHelp: 'Förse rutan med din VAT ID i international format, inklusive landskoden.',
      includeVat: 'inkl. VAT',
      firstName: 'Första namnet',
      lastName: 'Sista namnet',
      email: 'Email',
      company: 'Företag',
      street: 'Address',
      postalCode: 'Postkod',
      city: 'Stad',
      country: 'Land',
      emptyCardFields: 'Var god och fyll i detaljerna i ditt kreditkord',
      invalidValue: 'Värdet i fältet är ogiltigt',
      planNotSelected: 'Var god och välj en plan',
      totalPrice: 'Totalt',
      subscribed: 'Super! Din prenumeration är skapad.',
      subscriptionExists: 'Ert företag har redan en aktiv prenumeration. Var god och logga in for att ändra er prenumeration.',
      agreeTos: 'Jag har läst och godkänner ',
      agreeTosLinkText: 'Recrights användarvillkor.',
      privacyPolicy: 'Vi värdesätter din integritet, läs vår ',
      privacyPolicyLinkText: 'integritetspolicy.',
      licenseAgreement: 'Jag godkänner på min organisations vägnar ',
      licenseAgreementLinkText: 'Recrights Allmänna tjänstevillkor.',
      newsletter: 'Prenumerera till det månatliga nyhetsbrevet.',
      neverExpiresDiscount: amount => `Innehåller livstids rea ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) => `Innehåller rea på ${amount} EUR för ${cycles} månader`,
      errorFromProcessor: error => `Betalningshanteraren återkom med följande fel: ${error}`,
    },

    videos: {
      title: 'Videobibliotek',
      add: 'Skapa nytt videoklipp',
      rename: 'Byt namn',
      remove: 'Ta bort',
      yourVideos: 'Dina videon',
      companyVideos: 'Organisationens videon',
      confirmDeleteVideoTitle: 'Är du säker på att du vill ta bort denna video?',
      confirmDeleteVideoMessage: 'Detta kommer att ta bort videon från biblioteket och alla Collections.',
      addToCollection: 'Lägg till i samling',
    },

    userManagement: {
      excel: 'Exportera alla användare',
      title: 'Användarhantering',
      showCompanyDefaultPermissions: 'Visa företagets standard rättigheter',
      activateUserConfirm: 'Är du säker att du vill aktivera denna användare?',
      deactivateUserConfirm: 'Är du säker att du vill inaktivera denna användare?',
      showActivatedUsers: 'Visa aktiva användare',
      showDeactivatedUsers: 'Visa inaktiva användare',
      confirmCancelEditPermissions: {
        message: 'Du har osparade ändringar. Är du säker på att du vill radera alla ändringar?',
        cancel: 'Avbryt',
        confirm: 'Radera ändringarna',
      },
      unsavedChanges: 'Du har osparade ändringar. Vill du spara dessa ändringar?',
      confirm: 'Spara',
      permissionsChangesSaved: 'Användarrättigheterna ändrades framgångsrikt!',
      userDeactivated: nameOrEmail => `${nameOrEmail} deaktiverad`,
      userActivated: nameOrEmail => `${nameOrEmail} aktiverad`,
      companyDefaultsSaved: 'Standard administratörsrättigheterna ändrades framgånsrikt!',
      usersAddAdded: success => `${success} användarna är tillagda.`,
      usersAddExist: exist => `${exist} användarna finns redan i Recright.`,
      excel: 'Exportera alla användare',
    },

  },

}
